/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getBundles
// ====================================================

export interface getBundles_bundles_items_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * Заголовок характеристики
   */
  title: string;
}

export interface getBundles_bundles_items_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Характеристика
   */
  characteristic: getBundles_bundles_items_sku_characteristicValues_characteristic;
}

export interface getBundles_bundles_items_sku_photo_link240 {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getBundles_bundles_items_sku_photo_link540 {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getBundles_bundles_items_sku_photo_link720 {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getBundles_bundles_items_sku_photo {
  __typename: "Photo";
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link240: getBundles_bundles_items_sku_photo_link240;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link540: getBundles_bundles_items_sku_photo_link540;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link720: getBundles_bundles_items_sku_photo_link720;
}

export interface getBundles_bundles_items_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
}

export interface getBundles_bundles_items_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
}

export interface getBundles_bundles_items_sku_product {
  __typename: "Product";
  /**
   * ID продукта
   */
  id: number;
  /**
   * Название продукта
   */
  title: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Информация о временной скидке
   */
  offer: getBundles_bundles_items_sku_product_offer | null;
  /**
   * Информация о категории продукта
   */
  category: getBundles_bundles_items_sku_product_category | null;
}

export interface getBundles_bundles_items_sku {
  __typename: "Sku";
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: getBundles_bundles_items_sku_characteristicValues[];
  /**
   * Основная фотография для СКУ
   */
  photo: getBundles_bundles_items_sku_photo;
  /**
   * Продукт, к которому относится SKU
   */
  product: getBundles_bundles_items_sku_product;
}

export interface getBundles_bundles_items {
  __typename: "BundleItem";
  /**
   * ID товара в списке комбо-предложения (не id и не skuId товара, для клиентов смысла не несет)
   */
  id: number;
  /**
   * Размер скидки на SKU товара с примененным комбо-предложением
   */
  discountAmount: number;
  /**
   * SKU, участвующий в комбо-предложении
   */
  sku: getBundles_bundles_items_sku;
}

export interface getBundles_bundles {
  __typename: "Bundle";
  /**
   * ID набора
   */
  id: number;
  /**
   * Время, до которого действует предложение по комбо
   */
  dateCompleted: any | null;
  /**
   * SKU товаров в комбо-предложении. По трем товарам с пятью SKU на каждом придет
   * список из 15 элементов, при этом скидка будет считаться с учетом наличия
   * именно трех товаров в комбо
   */
  items: getBundles_bundles_items[];
}

export interface getBundles {
  bundles: getBundles_bundles[];
}

export interface getBundlesVariables {
  productIds?: number[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPromotionShelf
// ====================================================

export interface GetPromotionShelf_getPromotionShelf_cards_SkuGroupCard {
  __typename: "SkuGroupCard";
}

export interface GetPromotionShelf_getPromotionShelf_cards_ProductCard_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface GetPromotionShelf_getPromotionShelf_cards_ProductCard_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface GetPromotionShelf_getPromotionShelf_cards_ProductCard_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface GetPromotionShelf_getPromotionShelf_cards_ProductCard_photos {
  __typename: "Photo";
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: GetPromotionShelf_getPromotionShelf_cards_ProductCard_photos_link;
}

export interface GetPromotionShelf_getPromotionShelf_cards_ProductCard {
  __typename: "ProductCard";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Массив бейджей товара
   */
  badges: GetPromotionShelf_getPromotionShelf_cards_ProductCard_badges[];
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов для всего товара (не по отдельной SKU группе)
   */
  feedbackQuantity: number;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Плашка со скидкой с таймером
   */
  offer: GetPromotionShelf_getPromotionShelf_cards_ProductCard_offer | null;
  /**
   * Количество заказов для всего товара (не по отдельной SKU группе)
   */
  ordersQuantity: number;
  /**
   * Фотографии товара (приходит только главная пока)
   */
  photos: GetPromotionShelf_getPromotionShelf_cards_ProductCard_photos[];
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг товара (не отдельной SKU группы)
   */
  rating: number;
  /**
   * Название товара
   */
  title: string;
}

export type GetPromotionShelf_getPromotionShelf_cards = GetPromotionShelf_getPromotionShelf_cards_SkuGroupCard | GetPromotionShelf_getPromotionShelf_cards_ProductCard;

export interface GetPromotionShelf_getPromotionShelf_productWithBids_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface GetPromotionShelf_getPromotionShelf_productWithBids {
  __typename: "ProductWithBidID";
  /**
   * Product bid id
   */
  bidID: string | null;
  /**
   * Product entity identifier.
   */
  id: string | null;
  /**
   * ad promotion marker
   */
  adMarker: GetPromotionShelf_getPromotionShelf_productWithBids_adMarker | null;
}

export interface GetPromotionShelf_getPromotionShelf {
  __typename: "PromotionShelf";
  /**
   * Promotion shelf identifier.
   */
  id: string | null;
  /**
   * List of catalog cards.
   */
  cards: (GetPromotionShelf_getPromotionShelf_cards | null)[] | null;
  /**
   * List of products with bid ids
   */
  productWithBids: GetPromotionShelf_getPromotionShelf_productWithBids[];
}

export interface GetPromotionShelf {
  /**
   * Get promotion shelf.
   */
  getPromotionShelf: GetPromotionShelf_getPromotionShelf | null;
}

export interface GetPromotionShelfVariables {
  queryInput: GetPromotionShelfInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Suggestions
// ====================================================

export interface Suggestions_getSuggestions_blocks_SearchedEarlierBlock {
  __typename: "SearchedEarlierBlock" | "LookedEarlierBlock";
}

export interface Suggestions_getSuggestions_blocks_TextSuggestionsBlock {
  __typename: "TextSuggestionsBlock";
  /**
   * List of text suggestions.
   */
  values: string[] | null;
}

export interface Suggestions_getSuggestions_blocks_PopularSuggestionsBlock {
  __typename: "PopularSuggestionsBlock";
  /**
   * List of popular suggestions.
   */
  popularSuggestions: string[] | null;
}

export interface Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_SkuGroupCard {
  __typename: "SkuGroupCard";
}

export interface Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_ProductCard_photos_original {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
}

export interface Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_ProductCard_photos {
  __typename: "Photo";
  /**
   * Ссылка на оригинал фотографии
   */
  original: Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_ProductCard_photos_original;
}

export interface Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_ProductCard {
  __typename: "ProductCard";
  /**
   * Название товара
   */
  title: string;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Фотографии товара (приходит только главная пока)
   */
  photos: Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_ProductCard_photos[];
}

export type Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards = Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_SkuGroupCard | Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards_ProductCard;

export interface Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock {
  __typename: "CatalogCardSuggestionsBlock";
  /**
   * List of product suggestions.
   */
  cards: Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock_cards[] | null;
}

export interface Suggestions_getSuggestions_blocks_CategorySuggestionsBlock_categories_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface Suggestions_getSuggestions_blocks_CategorySuggestionsBlock_categories_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface Suggestions_getSuggestions_blocks_CategorySuggestionsBlock_categories {
  __typename: "Category";
  /**
   * Category title.
   */
  title: string;
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category parent.
   */
  parent: Suggestions_getSuggestions_blocks_CategorySuggestionsBlock_categories_parent | null;
  /**
   * Category SEO fields.
   */
  seo: Suggestions_getSuggestions_blocks_CategorySuggestionsBlock_categories_seo;
}

export interface Suggestions_getSuggestions_blocks_CategorySuggestionsBlock {
  __typename: "CategorySuggestionsBlock";
  /**
   * List of category suggestions.
   */
  categories: Suggestions_getSuggestions_blocks_CategorySuggestionsBlock_categories[] | null;
}

export interface Suggestions_getSuggestions_blocks_ShopSuggestionsBlock_shops_avatar {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
}

export interface Suggestions_getSuggestions_blocks_ShopSuggestionsBlock_shops {
  __typename: "Shop";
  /**
   * ID магазина
   */
  id: number;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
  /**
   * Аватарка магазина
   */
  avatar: Suggestions_getSuggestions_blocks_ShopSuggestionsBlock_shops_avatar | null;
}

export interface Suggestions_getSuggestions_blocks_ShopSuggestionsBlock {
  __typename: "ShopSuggestionsBlock";
  /**
   * List of category suggestions.
   */
  shops: Suggestions_getSuggestions_blocks_ShopSuggestionsBlock_shops[] | null;
}

export type Suggestions_getSuggestions_blocks = Suggestions_getSuggestions_blocks_SearchedEarlierBlock | Suggestions_getSuggestions_blocks_TextSuggestionsBlock | Suggestions_getSuggestions_blocks_PopularSuggestionsBlock | Suggestions_getSuggestions_blocks_CatalogCardSuggestionsBlock | Suggestions_getSuggestions_blocks_CategorySuggestionsBlock | Suggestions_getSuggestions_blocks_ShopSuggestionsBlock;

export interface Suggestions_getSuggestions {
  __typename: "GetSuggestionsResult";
  /**
   * Suggestions blocks.
   */
  blocks: (Suggestions_getSuggestions_blocks | null)[] | null;
}

export interface Suggestions {
  /**
   * Get search suggestions.
   */
  getSuggestions: Suggestions_getSuggestions;
}

export interface SuggestionsVariables {
  GetSuggestionsInput: GetSuggestionsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddCartItem
// ====================================================

export interface AddCartItem_addCartItems_sku_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface AddCartItem_addCartItems_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: AddCartItem_addCartItems_sku_characteristicValues_characteristic_values[];
}

export interface AddCartItem_addCartItems_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: AddCartItem_addCartItems_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface AddCartItem_addCartItems_sku_dimensions {
  __typename: "SkuDimension";
  /**
   * Высота
   */
  height: number | null;
  /**
   * Длина
   */
  length: number | null;
  /**
   * Ширина
   */
  width: number | null;
}

export interface AddCartItem_addCartItems_sku_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface AddCartItem_addCartItems_sku_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItem_addCartItems_sku_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: AddCartItem_addCartItems_sku_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface AddCartItem_addCartItems_sku_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItem_addCartItems_sku_photo_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItem_addCartItems_sku_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: AddCartItem_addCartItems_sku_photo_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: AddCartItem_addCartItems_sku_photo_original;
}

export interface AddCartItem_addCartItems_sku_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface AddCartItem_addCartItems_sku_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface AddCartItem_addCartItems_sku_product_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface AddCartItem_addCartItems_sku_product_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface AddCartItem_addCartItems_sku_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface AddCartItem_addCartItems_sku_product_category_children {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface AddCartItem_addCartItems_sku_product_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface AddCartItem_addCartItems_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Category parent.
   */
  parent: AddCartItem_addCartItems_sku_product_category_parent | null;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: AddCartItem_addCartItems_sku_product_category_parentList[];
  /**
   * List of category children.
   */
  children: AddCartItem_addCartItems_sku_product_category_children[];
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category SEO fields.
   */
  seo: AddCartItem_addCartItems_sku_product_category_seo;
}

export interface AddCartItem_addCartItems_sku_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface AddCartItem_addCartItems_sku_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface AddCartItem_addCartItems_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface AddCartItem_addCartItems_sku_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItem_addCartItems_sku_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface AddCartItem_addCartItems_sku_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: AddCartItem_addCartItems_sku_product_shop_seller_legalRecords[];
}

export interface AddCartItem_addCartItems_sku_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: AddCartItem_addCartItems_sku_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: AddCartItem_addCartItems_sku_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface AddCartItem_addCartItems_sku_product_skuList {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface AddCartItem_addCartItems_sku_product {
  __typename: "Product";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Массив бейджей товара
   */
  badges: AddCartItem_addCartItems_sku_product_badges[];
  /**
   * Информация о категории продукта
   */
  category: AddCartItem_addCartItems_sku_product_category | null;
  /**
   * Массив характеристик продукта
   */
  characteristics: AddCartItem_addCartItems_sku_product_characteristics[];
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: AddCartItem_addCartItems_sku_product_comments[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Флаг на наличие вертикальной фотографии
   */
  hasVerticalPhoto: boolean;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: AddCartItem_addCartItems_sku_product_offer | null;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: AddCartItem_addCartItems_sku_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: AddCartItem_addCartItems_sku_product_skuList[];
  /**
   * Название продукта
   */
  title: string;
}

export interface AddCartItem_addCartItems_sku_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface AddCartItem_addCartItems_sku_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: AddCartItem_addCartItems_sku_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface AddCartItem_addCartItems_sku_vat {
  __typename: "SkuVat";
  /**
   * Цена без НДС
   */
  price: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Коэфициент НДС
   */
  vatRate: number;
}

export interface AddCartItem_addCartItems_sku_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface AddCartItem_addCartItems_sku {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: AddCartItem_addCartItems_sku_characteristicValues[];
  /**
   * Размеры SKU
   */
  dimensions: AddCartItem_addCartItems_sku_dimensions;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: AddCartItem_addCartItems_sku_discountBadge | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: AddCartItem_addCartItems_sku_discountTimer | null;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Основная фотография для СКУ
   */
  photo: AddCartItem_addCartItems_sku_photo;
  /**
   * Фотографии 360
   */
  photo360: AddCartItem_addCartItems_sku_photo360[] | null;
  /**
   * Массив фотографий для СКУ
   */
  photos: AddCartItem_addCartItems_sku_photos[];
  /**
   * Продукт, к которому относится SKU
   */
  product: AddCartItem_addCartItems_sku_product;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: AddCartItem_addCartItems_sku_properties[] | null;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * НДС SKU
   */
  vat: AddCartItem_addCartItems_sku_vat | null;
  /**
   * Видео по SKU
   */
  video: AddCartItem_addCartItems_sku_video | null;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface AddCartItem_addCartItems {
  __typename: "CartItem";
  amount: number;
  sku: AddCartItem_addCartItems_sku;
}

export interface AddCartItem {
  addCartItems: AddCartItem_addCartItems[];
}

export interface AddCartItemVariables {
  cartItemInputs: CartItemInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddCartItems
// ====================================================

export interface AddCartItems_addCartItems_sku_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface AddCartItems_addCartItems_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: AddCartItems_addCartItems_sku_characteristicValues_characteristic_values[];
}

export interface AddCartItems_addCartItems_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: AddCartItems_addCartItems_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface AddCartItems_addCartItems_sku_dimensions {
  __typename: "SkuDimension";
  /**
   * Высота
   */
  height: number | null;
  /**
   * Длина
   */
  length: number | null;
  /**
   * Ширина
   */
  width: number | null;
}

export interface AddCartItems_addCartItems_sku_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface AddCartItems_addCartItems_sku_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItems_addCartItems_sku_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: AddCartItems_addCartItems_sku_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface AddCartItems_addCartItems_sku_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItems_addCartItems_sku_photo_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItems_addCartItems_sku_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: AddCartItems_addCartItems_sku_photo_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: AddCartItems_addCartItems_sku_photo_original;
}

export interface AddCartItems_addCartItems_sku_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface AddCartItems_addCartItems_sku_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface AddCartItems_addCartItems_sku_product_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface AddCartItems_addCartItems_sku_product_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface AddCartItems_addCartItems_sku_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface AddCartItems_addCartItems_sku_product_category_children {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface AddCartItems_addCartItems_sku_product_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface AddCartItems_addCartItems_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Category parent.
   */
  parent: AddCartItems_addCartItems_sku_product_category_parent | null;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: AddCartItems_addCartItems_sku_product_category_parentList[];
  /**
   * List of category children.
   */
  children: AddCartItems_addCartItems_sku_product_category_children[];
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category SEO fields.
   */
  seo: AddCartItems_addCartItems_sku_product_category_seo;
}

export interface AddCartItems_addCartItems_sku_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface AddCartItems_addCartItems_sku_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface AddCartItems_addCartItems_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface AddCartItems_addCartItems_sku_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface AddCartItems_addCartItems_sku_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface AddCartItems_addCartItems_sku_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: AddCartItems_addCartItems_sku_product_shop_seller_legalRecords[];
}

export interface AddCartItems_addCartItems_sku_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: AddCartItems_addCartItems_sku_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: AddCartItems_addCartItems_sku_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface AddCartItems_addCartItems_sku_product_skuList {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface AddCartItems_addCartItems_sku_product {
  __typename: "Product";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Массив бейджей товара
   */
  badges: AddCartItems_addCartItems_sku_product_badges[];
  /**
   * Информация о категории продукта
   */
  category: AddCartItems_addCartItems_sku_product_category | null;
  /**
   * Массив характеристик продукта
   */
  characteristics: AddCartItems_addCartItems_sku_product_characteristics[];
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: AddCartItems_addCartItems_sku_product_comments[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Флаг на наличие вертикальной фотографии
   */
  hasVerticalPhoto: boolean;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: AddCartItems_addCartItems_sku_product_offer | null;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: AddCartItems_addCartItems_sku_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: AddCartItems_addCartItems_sku_product_skuList[];
  /**
   * Название продукта
   */
  title: string;
}

export interface AddCartItems_addCartItems_sku_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface AddCartItems_addCartItems_sku_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: AddCartItems_addCartItems_sku_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface AddCartItems_addCartItems_sku_vat {
  __typename: "SkuVat";
  /**
   * Цена без НДС
   */
  price: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Коэфициент НДС
   */
  vatRate: number;
}

export interface AddCartItems_addCartItems_sku_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface AddCartItems_addCartItems_sku {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: AddCartItems_addCartItems_sku_characteristicValues[];
  /**
   * Размеры SKU
   */
  dimensions: AddCartItems_addCartItems_sku_dimensions;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: AddCartItems_addCartItems_sku_discountBadge | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: AddCartItems_addCartItems_sku_discountTimer | null;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Основная фотография для СКУ
   */
  photo: AddCartItems_addCartItems_sku_photo;
  /**
   * Фотографии 360
   */
  photo360: AddCartItems_addCartItems_sku_photo360[] | null;
  /**
   * Массив фотографий для СКУ
   */
  photos: AddCartItems_addCartItems_sku_photos[];
  /**
   * Продукт, к которому относится SKU
   */
  product: AddCartItems_addCartItems_sku_product;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: AddCartItems_addCartItems_sku_properties[] | null;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * НДС SKU
   */
  vat: AddCartItems_addCartItems_sku_vat | null;
  /**
   * Видео по SKU
   */
  video: AddCartItems_addCartItems_sku_video | null;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface AddCartItems_addCartItems {
  __typename: "CartItem";
  amount: number;
  sku: AddCartItems_addCartItems_sku;
}

export interface AddCartItems {
  addCartItems: AddCartItems_addCartItems[];
}

export interface AddCartItemsVariables {
  cartItemInputs: CartItemInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getCartCheckoutInformation
// ====================================================

export interface getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_city {
  __typename: "City";
  /**
   * ID города
   */
  id: number;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_errorBanner {
  __typename: "ErrorBanner";
  /**
   * Описание ограничения
   */
  description: string | null;
  /**
   * Причина ограничения
   */
  title: string | null;
  /**
   * Тип доступности курьерской доставки(аналитика)
   */
  deliveryTypeAvailable: string | null;
  /**
   * Тип нотификации(аналитика)
   */
  notificationType: string | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_schedule_days {
  __typename: "ScheduleDay";
  /**
   * Цвет текста
   */
  color: string;
  /**
   * День недели пн-вс
   */
  day: DayOfWeek;
  /**
   * Время начала работы ПВЗ, null - ПВЗ не работает в этот день
   */
  timeFrom: string | null;
  /**
   * Время окончания работы ПВЗ, null - ПВЗ не работает в этот день
   */
  timeTo: string | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_schedule {
  __typename: "Schedule";
  /**
   * Массив дней работы ПВЗ, всегда содержит 7 элементов пн-вс, даже если ПВЗ не работает в выходные
   */
  days: getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_schedule_days[];
}

export interface getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints {
  __typename: "DeliveryPoint";
  /**
   * Название ПВЗ
   */
  name: string | null;
  /**
   * Срок хранения заказа
   */
  shelfLife: number | null;
  /**
   * ID ПВЗ
   */
  id: number;
  /**
   * Адрес ПВЗ
   */
  address: string;
  /**
   * Город
   */
  city: getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_city;
  /**
   * Ближайшая дата доставки
   */
  deliveryDate: any | null;
  /**
   * Цена доставки
   */
  deliveryPrice: number | null;
  /**
   * Тип ПВЗ
   */
  type: DeliveryPointType;
  /**
   * Есть ли примерочная
   */
  hasDressingRoom: boolean;
  /**
   * Принимает ли возвраты
   */
  acceptReturns: boolean;
  /**
   * Ограничено
   */
  disabled: boolean | null;
  /**
   * Причина ограничения - устаревшее
   */
  disabledReason: string | null;
  /**
   * Причина ограничения
   */
  errorBanner: getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_errorBanner | null;
  /**
   * Ссылка на иконку доступного и выбранного ПВЗ
   */
  iconAvailableSelectedUrl: string | null;
  /**
   * Ссылка на иконку доступного ПВЗ
   */
  iconAvailableUrl: string | null;
  /**
   * Ссылка на иконку недоступного и выбранного ПВЗ
   */
  iconUnavailableSelectedUrl: string | null;
  /**
   * Ссылка на иконку недоступного ПВЗ
   */
  iconUnavailableUrl: string | null;
  /**
   * Широта
   */
  latitude: number;
  /**
   * Долгота
   */
  longitude: number;
  /**
   * Расписание работы ПВЗ
   */
  schedule: getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints_schedule;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_postamats_deliveryDate {
  __typename: "DeliveryOffer";
  date: any;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_postamats_schedule_days {
  __typename: "ScheduleDay";
  /**
   * Цвет текста
   */
  color: string;
  /**
   * День недели пн-вс
   */
  day: DayOfWeek;
  /**
   * Время начала работы ПВЗ, null - ПВЗ не работает в этот день
   */
  timeFrom: string | null;
  /**
   * Время окончания работы ПВЗ, null - ПВЗ не работает в этот день
   */
  timeTo: string | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_postamats_schedule {
  __typename: "Schedule";
  /**
   * Массив дней работы ПВЗ, всегда содержит 7 элементов пн-вс, даже если ПВЗ не работает в выходные
   */
  days: getCartCheckoutInformation_cartCheckoutInformation_postamats_schedule_days[];
}

export interface getCartCheckoutInformation_cartCheckoutInformation_postamats {
  __typename: "Postamat";
  /**
   * ID постамата
   */
  id: number;
  /**
   * Адрес постамата
   */
  address: string;
  /**
   * Цена доставки
   */
  deliveryPrice: number | null;
  /**
   * Дата доставки
   */
  deliveryDate: getCartCheckoutInformation_cartCheckoutInformation_postamats_deliveryDate;
  /**
   * Тип постамата
   */
  type: PostamatType;
  /**
   * Расписание работы постамата
   */
  schedule: getCartCheckoutInformation_cartCheckoutInformation_postamats_schedule;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_cartCalculations {
  __typename: "CartCalculation";
  /**
   * Цена корзины со скидками
   */
  cartTotalPrice: number;
  /**
   * Цена корзины без скидок
   */
  cartFullPrice: number;
  /**
   * Сумма скидки на всю корзину
   */
  discountAmount: number;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_courierDeliveryDates_options {
  __typename: "DeliveryOption";
  /**
   * Время начала таймслота
   */
  from: any;
  /**
   * Время окончания таймслота
   */
  to: any;
  /**
   * ID таймслота
   */
  id: number;
  /**
   * Стоимость доставки в этот таймслот
   */
  price: number;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_courierDeliveryDates {
  __typename: "DeliveryOffer";
  date: any;
  options: getCartCheckoutInformation_cartCheckoutInformation_courierDeliveryDates_options[];
}

export interface getCartCheckoutInformation_cartCheckoutInformation_courierDeliveryInfo {
  __typename: "CourierDeliveryInfo";
  /**
   * Текущая стоимость доставки курьером с учетом размера корзины
   */
  currentDeliveryPrice: number | null;
  /**
   * Минимальная сумма корзины для бесплатной доставки курьером
   */
  freeDeliveryMinAmount: number;
  /**
   * Стоимость доставки курьером для выбранного города
   */
  minDeliveryPrice: number | null;
  /**
   * Стоимость всего заказа с учетом текущей стоимости доставки курьером
   */
  totalOrderPrice: number | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_pvzDeliveryInfo {
  __typename: "PvzDeliveryInfo";
  /**
   * Текущая стоимость доставки до ПВЗ с учетом размера корзины
   */
  currentDeliveryPrice: number | null;
  /**
   * Минимальная сумма корзины, необходимая для бесплатной доставки в ПВЗ
   */
  freeDeliveryMinAmount: number;
  /**
   * Минимальная стоимость доставки в ПВЗ, если null, то в городе нет платной доставки
   */
  minDeliveryPrice: number | null;
  /**
   * Стоимость всего заказа с учетом текущей стоимости доставки
   */
  totalOrderPrice: number | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions_link {
  __typename: "BannerConditionsLink";
  /**
   * Текст для ссылки
   */
  text: string;
  url: string;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions_statements {
  __typename: "BannerConditionsStatements";
  /**
   * Текст условия
   */
  text: string | null;
  /**
   * Уточняющая информация по условию
   */
  description: string | null;
  /**
   * Название иконки
   */
  iconName: string | null;
  /**
   * Ссылка на картинку
   */
  imageUrl: string | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions_button {
  __typename: "BannerConditionsLink";
  url: string;
  /**
   * Текст для ссылки
   */
  text: string;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions {
  __typename: "BannerConditions";
  /**
   * Заголовок
   */
  title: string;
  /**
   * Ссылка на полные условия
   */
  link: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions_link;
  /**
   * Список условий
   */
  statements: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions_statements[];
  /**
   * Настройки кнопки
   */
  button: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions_button | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner {
  __typename: "CartPromotionBanner";
  /**
   * Заголовок баннера
   */
  title: string;
  /**
   * Описание баннера
   */
  description: string | null;
  /**
   * Картинка для баннера
   */
  image: string;
  /**
   * Условия, которые будут отображаться, при нажатии на баннер
   */
  conditions: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner_conditions | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction_CopyPromoCodeActionWidget {
  __typename: "CopyPromoCodeActionWidget";
  /**
   * Sku ID, который необходимо добавить в корзину
   */
  promoCode: string;
  /**
   * Ключевое слово для действия
   */
  actionMethod: string;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction_AddToCartActionWidget {
  __typename: "AddToCartActionWidget";
  /**
   * Sku ID, который необходимо добавить в корзину
   */
  skuId: number;
  /**
   * Ключевое слово для действия
   */
  actionMethod: string;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction_OpenDeepLinkActionWidget {
  __typename: "OpenDeepLinkActionWidget";
  /**
   * Deeplink для перехода
   */
  url: string;
  /**
   * Ключевое слово для действия
   */
  actionMethod: string;
}

export type getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction = getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction_CopyPromoCodeActionWidget | getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction_AddToCartActionWidget | getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction_OpenDeepLinkActionWidget;

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_button {
  __typename: "CartPromotionWidgetButton";
  /**
   * Наличие стрелки после текста
   */
  hasChevron: boolean;
  /**
   * Текст кнопки
   */
  text: string;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets {
  __typename: "CartPromotionWidget";
  id: number;
  /**
   * Тип иконки, которая должна отображаться в виджете
   */
  iconType: string;
  /**
   * Заголовок виджета
   */
  title: string;
  /**
   * Доступен ли виджет?
   */
  isAvailable: boolean;
  /**
   * Описание виджета
   */
  description: string | null;
  /**
   * Список цветов (для градиента)
   */
  backgroundColors: string[];
  /**
   * Действие, выполняемое при нажатии на виджет
   */
  widgetAction: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_widgetAction | null;
  /**
   * Настройки кнопки на виджете
   */
  button: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets_button | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation_promotionInCart {
  __typename: "CartPromotion";
  /**
   * Тип акции (ex. oneGift)
   */
  promotionType: string;
  /**
   * Главный баннер акции
   */
  banner: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_banner;
  /**
   * Виджеты, которые отображаются под баннером
   */
  widgets: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart_widgets[] | null;
}

export interface getCartCheckoutInformation_cartCheckoutInformation {
  __typename: "CartCheckoutInformation";
  deliveryPoints: getCartCheckoutInformation_cartCheckoutInformation_deliveryPoints[];
  postamats: (getCartCheckoutInformation_cartCheckoutInformation_postamats | null)[] | null;
  cartCalculations: getCartCheckoutInformation_cartCheckoutInformation_cartCalculations;
  courierDeliveryDates: (getCartCheckoutInformation_cartCheckoutInformation_courierDeliveryDates | null)[] | null;
  courierDeliveryInfo: getCartCheckoutInformation_cartCheckoutInformation_courierDeliveryInfo;
  pvzDeliveryInfo: getCartCheckoutInformation_cartCheckoutInformation_pvzDeliveryInfo;
  promotionInCart: getCartCheckoutInformation_cartCheckoutInformation_promotionInCart | null;
}

export interface getCartCheckoutInformation {
  cartCheckoutInformation: getCartCheckoutInformation_cartCheckoutInformation | null;
}

export interface getCartCheckoutInformationVariables {
  cartCheckoutInfoInput: CartCheckoutInformationInput;
  withDeliveryPoints: boolean;
  withPostamats: boolean;
  withPromotion: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: gqlCartCheckoutInformationDeliveryData
// ====================================================

export interface gqlCartCheckoutInformationDeliveryData_cartCheckoutInformation_courierDeliveryInfo {
  __typename: "CourierDeliveryInfo";
  /**
   * Текущая стоимость доставки курьером с учетом размера корзины
   */
  currentDeliveryPrice: number | null;
  /**
   * Минимальная сумма корзины для бесплатной доставки курьером
   */
  freeDeliveryMinAmount: number;
  /**
   * Стоимость доставки курьером для выбранного города
   */
  minDeliveryPrice: number | null;
  /**
   * Стоимость всего заказа с учетом текущей стоимости доставки курьером
   */
  totalOrderPrice: number | null;
}

export interface gqlCartCheckoutInformationDeliveryData_cartCheckoutInformation_pvzDeliveryInfo {
  __typename: "PvzDeliveryInfo";
  /**
   * Текущая стоимость доставки до ПВЗ с учетом размера корзины
   */
  currentDeliveryPrice: number | null;
  /**
   * Минимальная сумма корзины, необходимая для бесплатной доставки в ПВЗ
   */
  freeDeliveryMinAmount: number;
  /**
   * Минимальная стоимость доставки в ПВЗ, если null, то в городе нет платной доставки
   */
  minDeliveryPrice: number | null;
  /**
   * Стоимость всего заказа с учетом текущей стоимости доставки
   */
  totalOrderPrice: number | null;
}

export interface gqlCartCheckoutInformationDeliveryData_cartCheckoutInformation {
  __typename: "CartCheckoutInformation";
  courierDeliveryInfo: gqlCartCheckoutInformationDeliveryData_cartCheckoutInformation_courierDeliveryInfo;
  pvzDeliveryInfo: gqlCartCheckoutInformationDeliveryData_cartCheckoutInformation_pvzDeliveryInfo;
}

export interface gqlCartCheckoutInformationDeliveryData {
  cartCheckoutInformation: gqlCartCheckoutInformationDeliveryData_cartCheckoutInformation | null;
}

export interface gqlCartCheckoutInformationDeliveryDataVariables {
  cartCheckoutInfoInput: CartCheckoutInformationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Cart
// ====================================================

export interface Cart_cart_sku_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface Cart_cart_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: Cart_cart_sku_characteristicValues_characteristic_values[];
}

export interface Cart_cart_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: Cart_cart_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface Cart_cart_sku_dimensions {
  __typename: "SkuDimension";
  /**
   * Высота
   */
  height: number | null;
  /**
   * Длина
   */
  length: number | null;
  /**
   * Ширина
   */
  width: number | null;
}

export interface Cart_cart_sku_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface Cart_cart_sku_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Cart_cart_sku_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: Cart_cart_sku_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface Cart_cart_sku_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Cart_cart_sku_photo_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Cart_cart_sku_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: Cart_cart_sku_photo_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: Cart_cart_sku_photo_original;
}

export interface Cart_cart_sku_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface Cart_cart_sku_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface Cart_cart_sku_product_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface Cart_cart_sku_product_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface Cart_cart_sku_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface Cart_cart_sku_product_category_children {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface Cart_cart_sku_product_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface Cart_cart_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Category parent.
   */
  parent: Cart_cart_sku_product_category_parent | null;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: Cart_cart_sku_product_category_parentList[];
  /**
   * List of category children.
   */
  children: Cart_cart_sku_product_category_children[];
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category SEO fields.
   */
  seo: Cart_cart_sku_product_category_seo;
}

export interface Cart_cart_sku_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface Cart_cart_sku_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface Cart_cart_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface Cart_cart_sku_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Cart_cart_sku_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface Cart_cart_sku_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: Cart_cart_sku_product_shop_seller_legalRecords[];
}

export interface Cart_cart_sku_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: Cart_cart_sku_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: Cart_cart_sku_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface Cart_cart_sku_product_skuList {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface Cart_cart_sku_product {
  __typename: "Product";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Массив бейджей товара
   */
  badges: Cart_cart_sku_product_badges[];
  /**
   * Информация о категории продукта
   */
  category: Cart_cart_sku_product_category | null;
  /**
   * Массив характеристик продукта
   */
  characteristics: Cart_cart_sku_product_characteristics[];
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: Cart_cart_sku_product_comments[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Флаг на наличие вертикальной фотографии
   */
  hasVerticalPhoto: boolean;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: Cart_cart_sku_product_offer | null;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: Cart_cart_sku_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: Cart_cart_sku_product_skuList[];
  /**
   * Название продукта
   */
  title: string;
}

export interface Cart_cart_sku_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface Cart_cart_sku_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: Cart_cart_sku_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface Cart_cart_sku_vat {
  __typename: "SkuVat";
  /**
   * Цена без НДС
   */
  price: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Коэфициент НДС
   */
  vatRate: number;
}

export interface Cart_cart_sku_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface Cart_cart_sku {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: Cart_cart_sku_characteristicValues[];
  /**
   * Размеры SKU
   */
  dimensions: Cart_cart_sku_dimensions;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: Cart_cart_sku_discountBadge | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: Cart_cart_sku_discountTimer | null;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Основная фотография для СКУ
   */
  photo: Cart_cart_sku_photo;
  /**
   * Фотографии 360
   */
  photo360: Cart_cart_sku_photo360[] | null;
  /**
   * Массив фотографий для СКУ
   */
  photos: Cart_cart_sku_photos[];
  /**
   * Продукт, к которому относится SKU
   */
  product: Cart_cart_sku_product;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: Cart_cart_sku_properties[] | null;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * НДС SKU
   */
  vat: Cart_cart_sku_vat | null;
  /**
   * Видео по SKU
   */
  video: Cart_cart_sku_video | null;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface Cart_cart {
  __typename: "CartItem";
  amount: number;
  sku: Cart_cart_sku;
}

export interface Cart {
  cart: Cart_cart[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getExtendableOffer
// ====================================================

export interface getExtendableOffer_offer_CarouselOffer {
  __typename: "CarouselOffer" | "ImageOffer";
}

export interface getExtendableOffer_offer_ExtendableOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getExtendableOffer_offer_ExtendableOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getExtendableOffer_offer_ExtendableOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getExtendableOffer_offer_ExtendableOffer_products_badges = getExtendableOffer_offer_ExtendableOffer_products_badges_BottomIconTextBadge | getExtendableOffer_offer_ExtendableOffer_products_badges_BottomTextBadge;

export interface getExtendableOffer_offer_ExtendableOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getExtendableOffer_offer_ExtendableOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getExtendableOffer_offer_ExtendableOffer_products_photos_link;
}

export interface getExtendableOffer_offer_ExtendableOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getExtendableOffer_offer_ExtendableOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getExtendableOffer_offer_ExtendableOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getExtendableOffer_offer_ExtendableOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getExtendableOffer_offer_ExtendableOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getExtendableOffer_offer_ExtendableOffer_products_cardNearestDeliveryInfo | null;
}

export interface getExtendableOffer_offer_ExtendableOffer_category {
  __typename: "Category";
  /**
   * Category title.
   */
  title: string;
  /**
   * Category identifier.
   */
  id: number;
}

export interface getExtendableOffer_offer_ExtendableOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getExtendableOffer_offer_ExtendableOffer {
  __typename: "ExtendableOffer";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * ID подборки
   */
  id: number;
  /**
   * Массив карточек товара
   */
  products: getExtendableOffer_offer_ExtendableOffer_products[];
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getExtendableOffer_offer_ExtendableOffer_category;
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getExtendableOffer_offer_ExtendableOffer_adMarker | null;
}

export type getExtendableOffer_offer = getExtendableOffer_offer_CarouselOffer | getExtendableOffer_offer_ExtendableOffer;

export interface getExtendableOffer {
  offer: getExtendableOffer_offer;
}

export interface getExtendableOfferVariables {
  offerId: number;
  page: number;
  size: number;
  cityId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getMainContent
// ====================================================

export interface getMainContent_main_content_CollectionBlock {
  __typename: "CollectionBlock" | "NotificationWidgetBlock" | "StoriesBlock" | "TopOffersBlock";
}

export interface getMainContent_main_content_BannerBlock_content_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getMainContent_main_content_BannerBlock_content {
  __typename: "TopBanner";
  /**
   * Ссылка, которая открывается при нажатии на баннер
   */
  link: string | null;
  /**
   * Изображение баннера
   */
  image: getMainContent_main_content_BannerBlock_content_image;
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * ID баннера
   */
  id: number;
}

export interface getMainContent_main_content_BannerBlock {
  __typename: "BannerBlock";
  /**
   * Массив баннеров
   */
  content: getMainContent_main_content_BannerBlock_content[];
}

export interface getMainContent_main_content_ExtendableOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMainContent_main_content_ExtendableOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMainContent_main_content_ExtendableOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMainContent_main_content_ExtendableOffer_products_badges = getMainContent_main_content_ExtendableOffer_products_badges_BottomIconTextBadge | getMainContent_main_content_ExtendableOffer_products_badges_BottomTextBadge;

export interface getMainContent_main_content_ExtendableOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMainContent_main_content_ExtendableOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMainContent_main_content_ExtendableOffer_products_photos_link;
}

export interface getMainContent_main_content_ExtendableOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMainContent_main_content_ExtendableOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getMainContent_main_content_ExtendableOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getMainContent_main_content_ExtendableOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getMainContent_main_content_ExtendableOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMainContent_main_content_ExtendableOffer_products_cardNearestDeliveryInfo | null;
}

export interface getMainContent_main_content_ExtendableOffer_category {
  __typename: "Category";
  /**
   * Category title.
   */
  title: string;
  /**
   * Category identifier.
   */
  id: number;
}

export interface getMainContent_main_content_ExtendableOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent_main_content_ExtendableOffer {
  __typename: "ExtendableOffer";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * ID подборки
   */
  id: number;
  /**
   * Массив карточек товара
   */
  products: getMainContent_main_content_ExtendableOffer_products[];
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getMainContent_main_content_ExtendableOffer_category;
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getMainContent_main_content_ExtendableOffer_adMarker | null;
}

export interface getMainContent_main_content_ImageOffer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getMainContent_main_content_ImageOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getMainContent_main_content_ImageOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMainContent_main_content_ImageOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMainContent_main_content_ImageOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMainContent_main_content_ImageOffer_products_badges = getMainContent_main_content_ImageOffer_products_badges_BottomIconTextBadge | getMainContent_main_content_ImageOffer_products_badges_BottomTextBadge;

export interface getMainContent_main_content_ImageOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMainContent_main_content_ImageOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMainContent_main_content_ImageOffer_products_photos_link;
}

export interface getMainContent_main_content_ImageOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMainContent_main_content_ImageOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getMainContent_main_content_ImageOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getMainContent_main_content_ImageOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getMainContent_main_content_ImageOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMainContent_main_content_ImageOffer_products_cardNearestDeliveryInfo | null;
}

export interface getMainContent_main_content_ImageOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent_main_content_ImageOffer {
  __typename: "ImageOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Ссылка на большую фотографию подборки
   */
  image: getMainContent_main_content_ImageOffer_image;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getMainContent_main_content_ImageOffer_category;
  /**
   * Массив карточек товара
   */
  products: getMainContent_main_content_ImageOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getMainContent_main_content_ImageOffer_adMarker | null;
}

export interface getMainContent_main_content_CarouselOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getMainContent_main_content_CarouselOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMainContent_main_content_CarouselOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMainContent_main_content_CarouselOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMainContent_main_content_CarouselOffer_products_badges = getMainContent_main_content_CarouselOffer_products_badges_BottomIconTextBadge | getMainContent_main_content_CarouselOffer_products_badges_BottomTextBadge;

export interface getMainContent_main_content_CarouselOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMainContent_main_content_CarouselOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMainContent_main_content_CarouselOffer_products_photos_link;
}

export interface getMainContent_main_content_CarouselOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMainContent_main_content_CarouselOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getMainContent_main_content_CarouselOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getMainContent_main_content_CarouselOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getMainContent_main_content_CarouselOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMainContent_main_content_CarouselOffer_products_cardNearestDeliveryInfo | null;
}

export interface getMainContent_main_content_CarouselOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent_main_content_CarouselOffer {
  __typename: "CarouselOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getMainContent_main_content_CarouselOffer_category;
  /**
   * Массив карточек товара
   */
  products: getMainContent_main_content_CarouselOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getMainContent_main_content_CarouselOffer_adMarker | null;
}

export interface getMainContent_main_content_InlineBanner_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getMainContent_main_content_InlineBanner {
  __typename: "InlineBanner";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * Ссылка на большую фотографию баннера
   */
  image: getMainContent_main_content_InlineBanner_image;
  /**
   * Ссылка, которая открывается при нажатии на баннер
   */
  link: string | null;
  /**
   * ID блока баннера
   */
  id: number;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CollectionBlock {
  __typename: "CollectionBlock" | "PromoImageBlock";
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_badges = getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_badges_BottomIconTextBadge | getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_badges_BottomTextBadge;

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_photos_link;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_offer | null;
  /**
   * Массив бейджей
   */
  badges: getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content_cardNearestDeliveryInfo | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock {
  __typename: "CardBlock";
  /**
   * Массив карточек товара
   */
  content: getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock_content[];
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_badges = getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_badges_BottomIconTextBadge | getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_badges_BottomTextBadge;

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_photos_link;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products_cardNearestDeliveryInfo | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer {
  __typename: "CarouselOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_category;
  /**
   * Массив карточек товара
   */
  products: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer_adMarker | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_badges = getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_badges_BottomIconTextBadge | getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_badges_BottomTextBadge;

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_photos_link;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products_cardNearestDeliveryInfo | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer {
  __typename: "ImageOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Ссылка на большую фотографию подборки
   */
  image: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_image;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_category;
  /**
   * Массив карточек товара
   */
  products: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer_adMarker | null;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_InlineBanner_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getMainContent_main_content_VerticalOfferBlock_content_content_InlineBanner {
  __typename: "InlineBanner";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * Ссылка на большую фотографию баннера
   */
  image: getMainContent_main_content_VerticalOfferBlock_content_content_InlineBanner_image;
  /**
   * Ссылка, которая открывается при нажатии на баннер
   */
  link: string | null;
  /**
   * ID блока баннера
   */
  id: number;
}

export type getMainContent_main_content_VerticalOfferBlock_content_content = getMainContent_main_content_VerticalOfferBlock_content_content_CollectionBlock | getMainContent_main_content_VerticalOfferBlock_content_content_CardBlock | getMainContent_main_content_VerticalOfferBlock_content_content_CarouselOffer | getMainContent_main_content_VerticalOfferBlock_content_content_ImageOffer | getMainContent_main_content_VerticalOfferBlock_content_content_InlineBanner;

export interface getMainContent_main_content_VerticalOfferBlock_content {
  __typename: "VerticalOffer";
  /**
   * ID таба
   */
  id: number;
  /**
   * Заголовок таба
   */
  title: string;
  /**
   * Категория для оффера
   */
  category: getMainContent_main_content_VerticalOfferBlock_content_category | null;
  /**
   * Массив элементов таба главной страницы
   */
  content: getMainContent_main_content_VerticalOfferBlock_content_content[];
}

export interface getMainContent_main_content_VerticalOfferBlock {
  __typename: "VerticalOfferBlock";
  /**
   * Массив табов главной страницы
   */
  content: getMainContent_main_content_VerticalOfferBlock_content[];
}

export interface getMainContent_main_content_PromoImageBlock_content_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent_main_content_PromoImageBlock_content {
  __typename: "PromoImage";
  /**
   * Маркировка рекламы для баннера
   */
  adMarker: getMainContent_main_content_PromoImageBlock_content_adMarker | null;
  /**
   * Диплинк, куда ведет иконка
   */
  deepLink: string;
  /**
   * Иконка
   */
  iconLink: string;
  /**
   * ID промо категории
   */
  id: number;
  /**
   * Название
   */
  title: string;
}

export interface getMainContent_main_content_PromoImageBlock {
  __typename: "PromoImageBlock";
  content: getMainContent_main_content_PromoImageBlock_content[];
  linkTitle: string | null;
  link: string | null;
  id: number;
  titlePromo: string | null;
}

export type getMainContent_main_content = getMainContent_main_content_CollectionBlock | getMainContent_main_content_BannerBlock | getMainContent_main_content_ExtendableOffer | getMainContent_main_content_ImageOffer | getMainContent_main_content_CarouselOffer | getMainContent_main_content_InlineBanner | getMainContent_main_content_VerticalOfferBlock | getMainContent_main_content_PromoImageBlock;

export interface getMainContent_main {
  __typename: "MainPage";
  /**
   * Массив блоков главной страницы. Отличается в зависимости от переданного type (DESKTOP, MOBILE)
   */
  content: getMainContent_main_content[];
}

export interface getMainContent {
  main: getMainContent_main;
}

export interface getMainContentVariables {
  type: DisplayType;
  page: number;
  size: number;
  offerSize: number;
  offset: number;
  rowWidth: number;
  cityId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getMakeSearch
// ====================================================

export interface getMakeSearch_makeSearch_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getMakeSearch_makeSearch_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category parent.
   */
  parent: getMakeSearch_makeSearch_category_parent | null;
  /**
   * Category title.
   */
  title: string;
}

export interface getMakeSearch_makeSearch_categoryTree_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
}

export interface getMakeSearch_makeSearch_categoryTree_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface getMakeSearch_makeSearch_categoryTree_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category parent.
   */
  parent: getMakeSearch_makeSearch_categoryTree_category_parent | null;
  /**
   * Category SEO fields.
   */
  seo: getMakeSearch_makeSearch_categoryTree_category_seo;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
}

export interface getMakeSearch_makeSearch_categoryTree {
  __typename: "SearchResultCategoryTreeEntry";
  /**
   * Category.
   */
  category: getMakeSearch_makeSearch_categoryTree_category;
  /**
   * Total number of items found in the category.
   */
  total: number;
}

export interface getMakeSearch_makeSearch_items_adMarker {
  __typename: "AdMarker";
  orgInn: string | null;
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgName: string;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_badges = getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_badges_BottomIconTextBadge | getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_badges_BottomTextBadge;

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_photos_previewLink {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_photos_link;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  previewLink: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_photos_previewLink;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * Массив значений по характеристике
   */
  values: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_characteristicValues_characteristic_values[];
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * ID характеристики
   */
  id: number;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Характеристика
   */
  characteristic: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_characteristicValues_characteristic;
}

export interface getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard {
  __typename: "SkuGroupCard";
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_cardNearestDeliveryInfo | null;
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов для СКУ группы
   */
  feedbackQuantity: number;
  /**
   * ID СКУ группы (не продукта)
   */
  id: number;
  /**
   * Цена для отображения в каталоге до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в каталоге с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Плашка со скидкой с таймером
   */
  offer: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_offer | null;
  /**
   * Массив бейджей товара
   */
  badges: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_badges[];
  /**
   * Количество заказов для СКУ группы
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Название товара
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Фотографии СКУ группы (приходит только главная пока)
   */
  photos: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_photos[];
  /**
   * Значения характеристик для конкретной СКУ группы
   */
  characteristicValues: getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard_characteristicValues[];
}

export interface getMakeSearch_makeSearch_items_catalogCard_ProductCard_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getMakeSearch_makeSearch_items_catalogCard_ProductCard_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getMakeSearch_makeSearch_items_catalogCard_ProductCard_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getMakeSearch_makeSearch_items_catalogCard_ProductCard_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getMakeSearch_makeSearch_items_catalogCard_ProductCard_badges = getMakeSearch_makeSearch_items_catalogCard_ProductCard_badges_BottomIconTextBadge | getMakeSearch_makeSearch_items_catalogCard_ProductCard_badges_BottomTextBadge;

export interface getMakeSearch_makeSearch_items_catalogCard_ProductCard {
  __typename: "ProductCard";
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getMakeSearch_makeSearch_items_catalogCard_ProductCard_cardNearestDeliveryInfo | null;
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов для всего товара (не по отдельной SKU группе)
   */
  feedbackQuantity: number;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Плашка со скидкой с таймером
   */
  offer: getMakeSearch_makeSearch_items_catalogCard_ProductCard_offer | null;
  /**
   * Массив бейджей товара
   */
  badges: getMakeSearch_makeSearch_items_catalogCard_ProductCard_badges[];
  /**
   * Количество заказов для всего товара (не по отдельной SKU группе)
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг товара (не отдельной SKU группы)
   */
  rating: number;
  /**
   * Название товара
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
}

export type getMakeSearch_makeSearch_items_catalogCard = getMakeSearch_makeSearch_items_catalogCard_SkuGroupCard | getMakeSearch_makeSearch_items_catalogCard_ProductCard;

export interface getMakeSearch_makeSearch_items {
  __typename: "Item";
  /**
   * ad promotion marker
   */
  adMarker: getMakeSearch_makeSearch_items_adMarker | null;
  /**
   * Found SKU group.
   */
  catalogCard: getMakeSearch_makeSearch_items_catalogCard;
  /**
   * bid id
   */
  bidId: number | null;
}

export interface getMakeSearch_makeSearch_facets_filter {
  __typename: "Filter";
  /**
   * Product filter identifier.
   */
  id: number;
  title: string;
  type: FilterType;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  description: string | null;
}

export interface getMakeSearch_makeSearch_facets_buckets_filterValue {
  __typename: "FilterValue";
  /**
   * Product filter value identifier.
   */
  id: number;
  description: string | null;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface getMakeSearch_makeSearch_facets_buckets {
  __typename: "FacetBucket";
  /**
   * Filter value.
   */
  filterValue: getMakeSearch_makeSearch_facets_buckets_filterValue;
  /**
   * Total number of items with the bucket's filter value.
   */
  total: number;
}

export interface getMakeSearch_makeSearch_facets_range {
  __typename: "FacetRange";
  /**
   * Minimal value.
   */
  min: number;
  /**
   * Maximum value.
   */
  max: number;
}

export interface getMakeSearch_makeSearch_facets {
  __typename: "Facet";
  /**
   * Product filter.
   */
  filter: getMakeSearch_makeSearch_facets_filter;
  /**
   * Facet buckets.
   */
  buckets: getMakeSearch_makeSearch_facets_buckets[] | null;
  /**
   * Facet range.
   */
  range: getMakeSearch_makeSearch_facets_range | null;
}

export interface getMakeSearch_makeSearch_offerCategory {
  __typename: "Category";
  /**
   * Category title.
   */
  title: string;
  /**
   * Category identifier.
   */
  id: number;
}

export interface getMakeSearch_makeSearch_fastCategories_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getMakeSearch_makeSearch_fastCategories_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface getMakeSearch_makeSearch_fastCategories_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category parent.
   */
  parent: getMakeSearch_makeSearch_fastCategories_category_parent | null;
  /**
   * Category title.
   */
  title: string;
  /**
   * Category SEO fields.
   */
  seo: getMakeSearch_makeSearch_fastCategories_category_seo;
}

export interface getMakeSearch_makeSearch_fastCategories {
  __typename: "SearchResultCategoryTreeEntry";
  /**
   * Category.
   */
  category: getMakeSearch_makeSearch_fastCategories_category;
  /**
   * Total number of items found in the category.
   */
  total: number;
}

export interface getMakeSearch_makeSearch {
  __typename: "MakeSearchResult";
  /**
   * Result identifier.
   */
  id: string;
  /**
   * Search query identifier.
   */
  queryId: string;
  /**
   * Search query text.
   */
  queryText: string | null;
  /**
   * Category in which the items were found.
   */
  category: getMakeSearch_makeSearch_category | null;
  /**
   * Category tree. Returned only if the pagination has a limit of 0, else empty.
   */
  categoryTree: getMakeSearch_makeSearch_categoryTree[];
  /**
   * Found items.
   */
  items: getMakeSearch_makeSearch_items[] | null;
  /**
   * Product facets. Returned only if the pagination has a limit of 0, else empty.
   */
  facets: getMakeSearch_makeSearch_facets[] | null;
  /**
   * Total number of items found.
   */
  total: number;
  /**
   * Reports whether search result may have adult content.
   */
  mayHaveAdultContent: boolean;
  /**
   * Reports whether category was full matched.
   */
  categoryFullMatch: boolean;
  /**
   * Offer category in which the items were found.
   */
  offerCategory: getMakeSearch_makeSearch_offerCategory | null;
  /**
   * Corrected search query text.
   */
  correctedQueryText: string | null;
  /**
   * Reports whether category was predicted.
   */
  categoryWasPredicted: boolean;
  /**
   * Fast categories. Returned only if the pagination has a limit of 0, else empty.
   */
  fastCategories: getMakeSearch_makeSearch_fastCategories[];
  /**
   * Token for pagination.
   */
  token: string;
}

export interface getMakeSearch {
  /**
   * Makes search.
   */
  makeSearch: getMakeSearch_makeSearch;
}

export interface getMakeSearchVariables {
  queryInput: MakeSearchQueryInput;
  cityId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getOffer
// ====================================================

export interface getOffer_offer {
  __typename: "CarouselOffer" | "ImageOffer" | "ExtendableOffer";
  /**
   * Ссылка, которая открывается при нажатии на заголовок подборки
   */
  link: string;
  /**
   * ID подборки
   */
  id: number;
}

export interface getOffer {
  offer: getOffer_offer;
}

export interface getOfferVariables {
  offerId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Feedbacks
// ====================================================

export interface Feedbacks_productPage_feedbacks_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Feedbacks_productPage_feedbacks_photos_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Feedbacks_productPage_feedbacks_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: Feedbacks_productPage_feedbacks_photos_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: Feedbacks_productPage_feedbacks_photos_original;
}

export interface Feedbacks_productPage_feedbacks_reply_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface Feedbacks_productPage_feedbacks_reply_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface Feedbacks_productPage_feedbacks_reply_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: Feedbacks_productPage_feedbacks_reply_shop_seller_legalRecords[];
}

export interface Feedbacks_productPage_feedbacks_reply_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: Feedbacks_productPage_feedbacks_reply_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: Feedbacks_productPage_feedbacks_reply_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface Feedbacks_productPage_feedbacks_reply {
  __typename: "FeedbackReply";
  /**
   * Содержание ответа
   */
  content: string | null;
  /**
   * Дата создания ответа на отзыв
   */
  dateCreated: any | null;
  /**
   * ID ответа на отзыв
   */
  id: number;
  /**
   * Шоп который ответил на отзыв
   */
  shop: Feedbacks_productPage_feedbacks_reply_shop | null;
}

export interface Feedbacks_productPage_feedbacks_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface Feedbacks_productPage_feedbacks_sku_characteristicValues_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface Feedbacks_productPage_feedbacks_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: Feedbacks_productPage_feedbacks_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Фото значения характеристики
   */
  photo: Feedbacks_productPage_feedbacks_sku_characteristicValues_photo | null;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface Feedbacks_productPage_feedbacks_sku {
  __typename: "Sku";
  /**
   * ID SKU
   */
  id: number;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: Feedbacks_productPage_feedbacks_sku_characteristicValues[];
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
}

export interface Feedbacks_productPage_feedbacks {
  __typename: "Feedback";
  /**
   * Анонимный ли отзыв
   */
  anonymous: boolean;
  /**
   * Минусы
   */
  cons: string | null;
  /**
   * Комментарий
   */
  content: string | null;
  /**
   * Имя автора отзыва
   */
  customerName: string;
  /**
   * Дата создания отзыва
   */
  dateCreated: any;
  /**
   * Дата публикации отзыва
   */
  datePublished: any | null;
  /**
   * ID отзыва
   */
  id: number;
  /**
   * Фотографии отзыва
   */
  photos: Feedbacks_productPage_feedbacks_photos[] | null;
  /**
   * Плюсы
   */
  pros: string | null;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Ответ на отзыв
   */
  reply: Feedbacks_productPage_feedbacks_reply[] | null;
  /**
   * Ску на который был оставлен отзыв
   */
  sku: Feedbacks_productPage_feedbacks_sku;
}

export interface Feedbacks_productPage {
  __typename: "ProductPage";
  feedbacks: Feedbacks_productPage_feedbacks[] | null;
}

export interface Feedbacks {
  /**
   * Запрос на получение данных по странице товара
   */
  productPage: Feedbacks_productPage;
}

export interface FeedbacksVariables {
  productPageId: number;
  trans: Transformation;
  filters?: FeedbackFilterType[] | null;
  page: number;
  size: number;
  sort: FeedbackSortType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTabs
// ====================================================

export interface GetTabs_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface GetTabs_product {
  __typename: "Product";
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: GetTabs_product_comments[];
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
}

export interface GetTabs {
  product: GetTabs_product;
}

export interface GetTabsVariables {
  productId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProductPage
// ====================================================

export interface ProductPage_product_comments {
  __typename: "ProductComment";
  value: string;
  type: string;
}

export interface ProductPage_product_photo360_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: ProductPage_product_photo360_link;
}

export interface ProductPage_product_photos_thumbnail {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface ProductPage_product_photos_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface ProductPage_product_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  thumbnail: ProductPage_product_photos_thumbnail;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: ProductPage_product_photos_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: ProductPage_product_photos_original;
}

export interface ProductPage_product_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface ProductPage_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface ProductPage_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: ProductPage_product_category_parentList[];
  /**
   * Category title.
   */
  title: string;
}

export interface ProductPage_product_characteristics_values_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_characteristics_values_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: ProductPage_product_characteristics_values_photo_link;
}

export interface ProductPage_product_characteristics_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Фото значения характеристики
   */
  photo: ProductPage_product_characteristics_values_photo | null;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface ProductPage_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: ProductPage_product_characteristics_values[];
}

export interface ProductPage_product_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge";
  backgroundColor: string;
  description: string | null;
  iconLink: string;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export interface ProductPage_product_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export interface ProductPage_product_badges_TopTextBadge {
  __typename: "TopTextBadge";
  backgroundColor: string;
  id: number;
  text: string;
  textColor: string;
}

export type ProductPage_product_badges = ProductPage_product_badges_BottomIconTextBadge | ProductPage_product_badges_BottomTextBadge | ProductPage_product_badges_TopTextBadge;

export interface ProductPage_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface ProductPage_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: ProductPage_product_shop_seller_legalRecords[];
}

export interface ProductPage_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: ProductPage_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: ProductPage_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface ProductPage_product_skuList_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface ProductPage_product_skuList_skuGroup {
  __typename: "SkuGroup";
  /**
   * ID ску группы
   */
  id: number;
}

export interface ProductPage_product_skuList_photo_link {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_skuList_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: ProductPage_product_skuList_photo_link;
}

export interface ProductPage_product_skuList_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface ProductPage_product_skuList_paymentOptions {
  __typename: "ProductPaymentOption";
  /**
   * Ежемесячный платеж или пояснения к Долями
   */
  paymentInfo: string | null;
  /**
   * Название
   */
  text: string;
  /**
   * Тип плашки
   */
  type: ProductPaymentOptionType;
  /**
   * Старый optionId
   */
  id: number;
  /**
   * Доступен ли данный способ оплаты
   */
  active: boolean;
  /**
   * Текст заголовка для баннера
   */
  titleBanner: string | null;
}

export interface ProductPage_product_skuList_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface ProductPage_product_skuList_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: ProductPage_product_skuList_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface ProductPage_product_skuList_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface ProductPage_product_skuList_characteristicValues_photo_link {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_skuList_characteristicValues_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: ProductPage_product_skuList_characteristicValues_photo_link;
}

export interface ProductPage_product_skuList_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface ProductPage_product_skuList_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Фото значения характеристики
   */
  photo: ProductPage_product_skuList_characteristicValues_photo | null;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
  /**
   * Характеристика
   */
  characteristic: ProductPage_product_skuList_characteristicValues_characteristic;
}

export interface ProductPage_product_skuList_vat {
  __typename: "SkuVat";
  /**
   * Коэфициент НДС
   */
  vatRate: number;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Цена без НДС
   */
  price: number;
}

export interface ProductPage_product_skuList_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface ProductPage_product_skuList_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: ProductPage_product_skuList_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface ProductPage_product_skuList {
  __typename: "Sku";
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: ProductPage_product_skuList_cardNearestDeliveryInfo | null;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Ску группа
   */
  skuGroup: ProductPage_product_skuList_skuGroup | null;
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Основная фотография для СКУ
   */
  photo: ProductPage_product_skuList_photo;
  /**
   * Видео по SKU
   */
  video: ProductPage_product_skuList_video | null;
  /**
   * Долями, рассрочка и прочие способы оплаты
   */
  paymentOptions: ProductPage_product_skuList_paymentOptions[] | null;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: ProductPage_product_skuList_properties[] | null;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: ProductPage_product_skuList_discountBadge | null;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: ProductPage_product_skuList_characteristicValues[];
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * НДС SKU
   */
  vat: ProductPage_product_skuList_vat | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: ProductPage_product_skuList_discountTimer | null;
}

export interface ProductPage_product_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface ProductPage_product {
  __typename: "Product";
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Внешний рейтинг товара
   */
  externalRating: boolean | null;
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: ProductPage_product_comments[];
  /**
   * Фотографии 360
   */
  photo360: ProductPage_product_photo360[] | null;
  /**
   * Массив всех фотографий товара
   */
  photos: ProductPage_product_photos[];
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Видео с товаром
   */
  video: ProductPage_product_video | null;
  /**
   * Название продукта
   */
  title: string;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Информация о категории продукта
   */
  category: ProductPage_product_category | null;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Массив характеристик продукта
   */
  characteristics: ProductPage_product_characteristics[];
  /**
   * Массив бейджей товара
   */
  badges: ProductPage_product_badges[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: ProductPage_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: ProductPage_product_skuList[];
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: ProductPage_product_cardNearestDeliveryInfo | null;
}

export interface ProductPage_productPage_actions_ProductBanner {
  __typename: "ProductBanner";
  /**
   * Место для отображения плашки
   */
  location: ProductActionLocation;
  /**
   * Отображать только известные типы, в случае неизвестного игнорировать!
   */
  type: ProductActionType;
}

export interface ProductPage_productPage_actions_MotivationAction_image {
  __typename: "PhotoLink";
  /**
   * В низком качестве
   */
  low: string;
  /**
   * В высоком качестве
   */
  high: string;
}

export interface ProductPage_productPage_actions_MotivationAction {
  __typename: "MotivationAction";
  /**
   * Место для отображения плашки
   */
  location: ProductActionLocation;
  /**
   * Отображать только известные типы, в случае неизвестного игнорировать!
   */
  type: ProductActionType;
  /**
   * Картинка в png/jpg формате
   */
  image: ProductPage_productPage_actions_MotivationAction_image;
  /**
   * Текст для отображения
   */
  text: string;
}

export interface ProductPage_productPage_actions_WishSaleAction {
  __typename: "WishSaleAction";
  /**
   * Место для отображения плашки
   */
  location: ProductActionLocation;
  /**
   * Отображать только известные типы, в случае неизвестного игнорировать!
   */
  type: ProductActionType;
  /**
   * Дата окончания
   */
  dateEnd: any;
  /**
   * Нажал ли пользователь кнопку 'Хочу скидку'
   */
  pressed: boolean;
  /**
   * Количество пользователей, которые нажали на кнопку 'Хочу скидку'
   */
  pressedCount: number;
}

export type ProductPage_productPage_actions = ProductPage_productPage_actions_ProductBanner | ProductPage_productPage_actions_MotivationAction | ProductPage_productPage_actions_WishSaleAction;

export interface ProductPage_productPage {
  __typename: "ProductPage";
  reviewsPhotoAmount: number | null;
  /**
   * Actions 'Этот товар смотрят 285 человек'
   */
  actions: ProductPage_productPage_actions[] | null;
}

export interface ProductPage {
  product: ProductPage_product;
  /**
   * Запрос на получение данных по странице товара
   */
  productPage: ProductPage_productPage;
}

export interface ProductPageVariables {
  productId: number;
  cityId: number;
  linkTrans4: Transformation;
  linkTrans6: Transformation;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getProduct
// ====================================================

export interface getProduct_product_skuList {
  __typename: "Sku";
  /**
   * ID SKU
   */
  id: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
}

export interface getProduct_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getProduct_product_category {
  __typename: "Category";
  /**
   * Category title.
   */
  title: string;
}

export interface getProduct_product_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getProduct_product_photos {
  __typename: "Photo";
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getProduct_product_photos_link;
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface getProduct_product_shop {
  __typename: "Shop";
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface getProduct_product {
  __typename: "Product";
  /**
   * ID продукта
   */
  id: number;
  /**
   * Название продукта
   */
  title: string;
  /**
   * Массив SKU
   */
  skuList: getProduct_product_skuList[];
  /**
   * Информация о временной скидке
   */
  offer: getProduct_product_offer | null;
  /**
   * Информация о категории продукта
   */
  category: getProduct_product_category | null;
  /**
   * Массив всех фотографий товара
   */
  photos: getProduct_product_photos[];
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: getProduct_product_shop | null;
}

export interface getProduct {
  product: getProduct_product;
}

export interface getProductVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getProductSkuIds
// ====================================================

export interface getProductSkuIds_product_skuList {
  __typename: "Sku";
  /**
   * ID SKU
   */
  id: number;
}

export interface getProductSkuIds_product {
  __typename: "Product";
  /**
   * ID продукта
   */
  id: number;
  /**
   * Название продукта
   */
  title: string;
  /**
   * Массив SKU
   */
  skuList: getProductSkuIds_product_skuList[];
}

export interface getProductSkuIds {
  product: getProductSkuIds_product;
}

export interface getProductSkuIdsVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getMainContent2
// ====================================================

export interface getMainContent2_main_content_BannerBlock {
  __typename: "BannerBlock" | "CarouselOffer" | "CollectionBlock" | "ExtendableOffer" | "ImageOffer" | "InlineBanner" | "NotificationWidgetBlock" | "StoriesBlock" | "TopOffersBlock" | "VerticalOfferBlock";
}

export interface getMainContent2_main_content_PromoImageBlock_content_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getMainContent2_main_content_PromoImageBlock_content {
  __typename: "PromoImage";
  /**
   * Маркировка рекламы для баннера
   */
  adMarker: getMainContent2_main_content_PromoImageBlock_content_adMarker | null;
  /**
   * Диплинк, куда ведет иконка
   */
  deepLink: string;
  /**
   * Иконка
   */
  iconLink: string;
  /**
   * ID промо категории
   */
  id: number;
  /**
   * Название
   */
  title: string;
}

export interface getMainContent2_main_content_PromoImageBlock {
  __typename: "PromoImageBlock";
  content: getMainContent2_main_content_PromoImageBlock_content[];
}

export type getMainContent2_main_content = getMainContent2_main_content_BannerBlock | getMainContent2_main_content_PromoImageBlock;

export interface getMainContent2_main {
  __typename: "MainPage";
  /**
   * Массив блоков главной страницы. Отличается в зависимости от переданного type (DESKTOP, MOBILE)
   */
  content: getMainContent2_main_content[];
}

export interface getMainContent2 {
  main: getMainContent2_main;
}

export interface getMainContent2Variables {
  type: DisplayType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Search
// ====================================================

export interface Search_search_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface Search_search_skuList {
  __typename: "Sku";
  /**
   * ID SKU
   */
  id: number;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
}

export interface Search_search {
  __typename: "Product";
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Массив бейджей товара
   */
  badges: Search_search_badges[];
  /**
   * Название продукта
   */
  title: string;
  /**
   * Массив SKU
   */
  skuList: Search_search_skuList[];
}

export interface Search {
  search: Search_search[];
}

export interface SearchVariables {
  input: SearchArgs;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetCartItems
// ====================================================

export interface SetCartItems_setCartItems_sku_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface SetCartItems_setCartItems_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: SetCartItems_setCartItems_sku_characteristicValues_characteristic_values[];
}

export interface SetCartItems_setCartItems_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: SetCartItems_setCartItems_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface SetCartItems_setCartItems_sku_dimensions {
  __typename: "SkuDimension";
  /**
   * Высота
   */
  height: number | null;
  /**
   * Длина
   */
  length: number | null;
  /**
   * Ширина
   */
  width: number | null;
}

export interface SetCartItems_setCartItems_sku_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface SetCartItems_setCartItems_sku_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SetCartItems_setCartItems_sku_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: SetCartItems_setCartItems_sku_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface SetCartItems_setCartItems_sku_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SetCartItems_setCartItems_sku_photo_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SetCartItems_setCartItems_sku_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: SetCartItems_setCartItems_sku_photo_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: SetCartItems_setCartItems_sku_photo_original;
}

export interface SetCartItems_setCartItems_sku_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface SetCartItems_setCartItems_sku_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface SetCartItems_setCartItems_sku_product_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface SetCartItems_setCartItems_sku_product_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface SetCartItems_setCartItems_sku_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface SetCartItems_setCartItems_sku_product_category_children {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface SetCartItems_setCartItems_sku_product_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface SetCartItems_setCartItems_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Category parent.
   */
  parent: SetCartItems_setCartItems_sku_product_category_parent | null;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: SetCartItems_setCartItems_sku_product_category_parentList[];
  /**
   * List of category children.
   */
  children: SetCartItems_setCartItems_sku_product_category_children[];
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category SEO fields.
   */
  seo: SetCartItems_setCartItems_sku_product_category_seo;
}

export interface SetCartItems_setCartItems_sku_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface SetCartItems_setCartItems_sku_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface SetCartItems_setCartItems_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface SetCartItems_setCartItems_sku_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SetCartItems_setCartItems_sku_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface SetCartItems_setCartItems_sku_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: SetCartItems_setCartItems_sku_product_shop_seller_legalRecords[];
}

export interface SetCartItems_setCartItems_sku_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: SetCartItems_setCartItems_sku_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: SetCartItems_setCartItems_sku_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface SetCartItems_setCartItems_sku_product_skuList {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface SetCartItems_setCartItems_sku_product {
  __typename: "Product";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Массив бейджей товара
   */
  badges: SetCartItems_setCartItems_sku_product_badges[];
  /**
   * Информация о категории продукта
   */
  category: SetCartItems_setCartItems_sku_product_category | null;
  /**
   * Массив характеристик продукта
   */
  characteristics: SetCartItems_setCartItems_sku_product_characteristics[];
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: SetCartItems_setCartItems_sku_product_comments[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Флаг на наличие вертикальной фотографии
   */
  hasVerticalPhoto: boolean;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: SetCartItems_setCartItems_sku_product_offer | null;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: SetCartItems_setCartItems_sku_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: SetCartItems_setCartItems_sku_product_skuList[];
  /**
   * Название продукта
   */
  title: string;
}

export interface SetCartItems_setCartItems_sku_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface SetCartItems_setCartItems_sku_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: SetCartItems_setCartItems_sku_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface SetCartItems_setCartItems_sku_vat {
  __typename: "SkuVat";
  /**
   * Цена без НДС
   */
  price: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Коэфициент НДС
   */
  vatRate: number;
}

export interface SetCartItems_setCartItems_sku_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface SetCartItems_setCartItems_sku {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: SetCartItems_setCartItems_sku_characteristicValues[];
  /**
   * Размеры SKU
   */
  dimensions: SetCartItems_setCartItems_sku_dimensions;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: SetCartItems_setCartItems_sku_discountBadge | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: SetCartItems_setCartItems_sku_discountTimer | null;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Основная фотография для СКУ
   */
  photo: SetCartItems_setCartItems_sku_photo;
  /**
   * Фотографии 360
   */
  photo360: SetCartItems_setCartItems_sku_photo360[] | null;
  /**
   * Массив фотографий для СКУ
   */
  photos: SetCartItems_setCartItems_sku_photos[];
  /**
   * Продукт, к которому относится SKU
   */
  product: SetCartItems_setCartItems_sku_product;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: SetCartItems_setCartItems_sku_properties[] | null;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * НДС SKU
   */
  vat: SetCartItems_setCartItems_sku_vat | null;
  /**
   * Видео по SKU
   */
  video: SetCartItems_setCartItems_sku_video | null;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface SetCartItems_setCartItems {
  __typename: "CartItem";
  amount: number;
  sku: SetCartItems_setCartItems_sku;
}

export interface SetCartItems {
  setCartItems: SetCartItems_setCartItems[];
}

export interface SetCartItemsVariables {
  cartItemInputs: CartItemInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SynchronizeCart
// ====================================================

export interface SynchronizeCart_synchronizeCart_sku_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface SynchronizeCart_synchronizeCart_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: SynchronizeCart_synchronizeCart_sku_characteristicValues_characteristic_values[];
}

export interface SynchronizeCart_synchronizeCart_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: SynchronizeCart_synchronizeCart_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface SynchronizeCart_synchronizeCart_sku_dimensions {
  __typename: "SkuDimension";
  /**
   * Высота
   */
  height: number | null;
  /**
   * Длина
   */
  length: number | null;
  /**
   * Ширина
   */
  width: number | null;
}

export interface SynchronizeCart_synchronizeCart_sku_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface SynchronizeCart_synchronizeCart_sku_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SynchronizeCart_synchronizeCart_sku_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: SynchronizeCart_synchronizeCart_sku_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface SynchronizeCart_synchronizeCart_sku_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SynchronizeCart_synchronizeCart_sku_photo_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SynchronizeCart_synchronizeCart_sku_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: SynchronizeCart_synchronizeCart_sku_photo_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: SynchronizeCart_synchronizeCart_sku_photo_original;
}

export interface SynchronizeCart_synchronizeCart_sku_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface SynchronizeCart_synchronizeCart_sku_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface SynchronizeCart_synchronizeCart_sku_product_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface SynchronizeCart_synchronizeCart_sku_product_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface SynchronizeCart_synchronizeCart_sku_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface SynchronizeCart_synchronizeCart_sku_product_category_children {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface SynchronizeCart_synchronizeCart_sku_product_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface SynchronizeCart_synchronizeCart_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Category parent.
   */
  parent: SynchronizeCart_synchronizeCart_sku_product_category_parent | null;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: SynchronizeCart_synchronizeCart_sku_product_category_parentList[];
  /**
   * List of category children.
   */
  children: SynchronizeCart_synchronizeCart_sku_product_category_children[];
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category SEO fields.
   */
  seo: SynchronizeCart_synchronizeCart_sku_product_category_seo;
}

export interface SynchronizeCart_synchronizeCart_sku_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface SynchronizeCart_synchronizeCart_sku_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface SynchronizeCart_synchronizeCart_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface SynchronizeCart_synchronizeCart_sku_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SynchronizeCart_synchronizeCart_sku_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface SynchronizeCart_synchronizeCart_sku_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: SynchronizeCart_synchronizeCart_sku_product_shop_seller_legalRecords[];
}

export interface SynchronizeCart_synchronizeCart_sku_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: SynchronizeCart_synchronizeCart_sku_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: SynchronizeCart_synchronizeCart_sku_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface SynchronizeCart_synchronizeCart_sku_product_skuList {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface SynchronizeCart_synchronizeCart_sku_product {
  __typename: "Product";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Массив бейджей товара
   */
  badges: SynchronizeCart_synchronizeCart_sku_product_badges[];
  /**
   * Информация о категории продукта
   */
  category: SynchronizeCart_synchronizeCart_sku_product_category | null;
  /**
   * Массив характеристик продукта
   */
  characteristics: SynchronizeCart_synchronizeCart_sku_product_characteristics[];
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: SynchronizeCart_synchronizeCart_sku_product_comments[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Флаг на наличие вертикальной фотографии
   */
  hasVerticalPhoto: boolean;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: SynchronizeCart_synchronizeCart_sku_product_offer | null;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: SynchronizeCart_synchronizeCart_sku_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: SynchronizeCart_synchronizeCart_sku_product_skuList[];
  /**
   * Название продукта
   */
  title: string;
}

export interface SynchronizeCart_synchronizeCart_sku_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface SynchronizeCart_synchronizeCart_sku_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: SynchronizeCart_synchronizeCart_sku_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface SynchronizeCart_synchronizeCart_sku_vat {
  __typename: "SkuVat";
  /**
   * Цена без НДС
   */
  price: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Коэфициент НДС
   */
  vatRate: number;
}

export interface SynchronizeCart_synchronizeCart_sku_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface SynchronizeCart_synchronizeCart_sku {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: SynchronizeCart_synchronizeCart_sku_characteristicValues[];
  /**
   * Размеры SKU
   */
  dimensions: SynchronizeCart_synchronizeCart_sku_dimensions;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: SynchronizeCart_synchronizeCart_sku_discountBadge | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: SynchronizeCart_synchronizeCart_sku_discountTimer | null;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Основная фотография для СКУ
   */
  photo: SynchronizeCart_synchronizeCart_sku_photo;
  /**
   * Фотографии 360
   */
  photo360: SynchronizeCart_synchronizeCart_sku_photo360[] | null;
  /**
   * Массив фотографий для СКУ
   */
  photos: SynchronizeCart_synchronizeCart_sku_photos[];
  /**
   * Продукт, к которому относится SKU
   */
  product: SynchronizeCart_synchronizeCart_sku_product;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: SynchronizeCart_synchronizeCart_sku_properties[] | null;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * НДС SKU
   */
  vat: SynchronizeCart_synchronizeCart_sku_vat | null;
  /**
   * Видео по SKU
   */
  video: SynchronizeCart_synchronizeCart_sku_video | null;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface SynchronizeCart_synchronizeCart {
  __typename: "CartItem";
  amount: number;
  sku: SynchronizeCart_synchronizeCart_sku;
}

export interface SynchronizeCart {
  synchronizeCart: SynchronizeCart_synchronizeCart[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getVerticalOffer
// ====================================================

export interface getVerticalOffer_verticalOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
}

export interface getVerticalOffer_verticalOffer_content_CollectionBlock {
  __typename: "CollectionBlock" | "PromoImageBlock";
}

export interface getVerticalOffer_verticalOffer_content_CardBlock_content_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getVerticalOffer_verticalOffer_content_CardBlock_content_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getVerticalOffer_verticalOffer_content_CardBlock_content_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getVerticalOffer_verticalOffer_content_CardBlock_content_badges = getVerticalOffer_verticalOffer_content_CardBlock_content_badges_BottomIconTextBadge | getVerticalOffer_verticalOffer_content_CardBlock_content_badges_BottomTextBadge;

export interface getVerticalOffer_verticalOffer_content_CardBlock_content_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getVerticalOffer_verticalOffer_content_CardBlock_content_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getVerticalOffer_verticalOffer_content_CardBlock_content_photos_link;
}

export interface getVerticalOffer_verticalOffer_content_CardBlock_content_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getVerticalOffer_verticalOffer_content_CardBlock_content {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getVerticalOffer_verticalOffer_content_CardBlock_content_offer | null;
  /**
   * Массив бейджей
   */
  badges: getVerticalOffer_verticalOffer_content_CardBlock_content_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getVerticalOffer_verticalOffer_content_CardBlock_content_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getVerticalOffer_verticalOffer_content_CardBlock_content_cardNearestDeliveryInfo | null;
}

export interface getVerticalOffer_verticalOffer_content_CardBlock {
  __typename: "CardBlock";
  /**
   * Массив карточек товара
   */
  content: getVerticalOffer_verticalOffer_content_CardBlock_content[];
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getVerticalOffer_verticalOffer_content_CarouselOffer_products_badges = getVerticalOffer_verticalOffer_content_CarouselOffer_products_badges_BottomIconTextBadge | getVerticalOffer_verticalOffer_content_CarouselOffer_products_badges_BottomTextBadge;

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getVerticalOffer_verticalOffer_content_CarouselOffer_products_photos_link;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getVerticalOffer_verticalOffer_content_CarouselOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getVerticalOffer_verticalOffer_content_CarouselOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getVerticalOffer_verticalOffer_content_CarouselOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getVerticalOffer_verticalOffer_content_CarouselOffer_products_cardNearestDeliveryInfo | null;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getVerticalOffer_verticalOffer_content_CarouselOffer {
  __typename: "CarouselOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getVerticalOffer_verticalOffer_content_CarouselOffer_category;
  /**
   * Массив карточек товара
   */
  products: getVerticalOffer_verticalOffer_content_CarouselOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getVerticalOffer_verticalOffer_content_CarouselOffer_adMarker | null;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type getVerticalOffer_verticalOffer_content_ImageOffer_products_badges = getVerticalOffer_verticalOffer_content_ImageOffer_products_badges_BottomIconTextBadge | getVerticalOffer_verticalOffer_content_ImageOffer_products_badges_BottomTextBadge;

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: getVerticalOffer_verticalOffer_content_ImageOffer_products_photos_link;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: getVerticalOffer_verticalOffer_content_ImageOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: getVerticalOffer_verticalOffer_content_ImageOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: getVerticalOffer_verticalOffer_content_ImageOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: getVerticalOffer_verticalOffer_content_ImageOffer_products_cardNearestDeliveryInfo | null;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface getVerticalOffer_verticalOffer_content_ImageOffer {
  __typename: "ImageOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Ссылка на большую фотографию подборки
   */
  image: getVerticalOffer_verticalOffer_content_ImageOffer_image;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: getVerticalOffer_verticalOffer_content_ImageOffer_category;
  /**
   * Массив карточек товара
   */
  products: getVerticalOffer_verticalOffer_content_ImageOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: getVerticalOffer_verticalOffer_content_ImageOffer_adMarker | null;
}

export interface getVerticalOffer_verticalOffer_content_InlineBanner_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface getVerticalOffer_verticalOffer_content_InlineBanner {
  __typename: "InlineBanner";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * Ссылка на большую фотографию баннера
   */
  image: getVerticalOffer_verticalOffer_content_InlineBanner_image;
  /**
   * Ссылка, которая открывается при нажатии на баннер
   */
  link: string | null;
  /**
   * ID блока баннера
   */
  id: number;
}

export type getVerticalOffer_verticalOffer_content = getVerticalOffer_verticalOffer_content_CollectionBlock | getVerticalOffer_verticalOffer_content_CardBlock | getVerticalOffer_verticalOffer_content_CarouselOffer | getVerticalOffer_verticalOffer_content_ImageOffer | getVerticalOffer_verticalOffer_content_InlineBanner;

export interface getVerticalOffer_verticalOffer {
  __typename: "VerticalOffer";
  /**
   * ID таба
   */
  id: number;
  /**
   * Заголовок таба
   */
  title: string;
  /**
   * Категория для оффера
   */
  category: getVerticalOffer_verticalOffer_category | null;
  /**
   * Массив элементов таба главной страницы
   */
  content: getVerticalOffer_verticalOffer_content[];
}

export interface getVerticalOffer {
  verticalOffer: getVerticalOffer_verticalOffer;
}

export interface getVerticalOfferVariables {
  offerId: number;
  displayType: DisplayType;
  offset: number;
  rowWidth: number;
  offerSize: number;
  cityId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CartFragment
// ====================================================

export interface CartFragment_sku_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface CartFragment_sku_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
  /**
   * Массив значений по характеристике
   */
  values: CartFragment_sku_characteristicValues_characteristic_values[];
}

export interface CartFragment_sku_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * Характеристика
   */
  characteristic: CartFragment_sku_characteristicValues_characteristic;
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface CartFragment_sku_dimensions {
  __typename: "SkuDimension";
  /**
   * Высота
   */
  height: number | null;
  /**
   * Длина
   */
  length: number | null;
  /**
   * Ширина
   */
  width: number | null;
}

export interface CartFragment_sku_discountBadge {
  __typename: "SkuDiscountBadge";
  /**
   * hex цвет фона
   */
  backgroundColor: string;
  /**
   * ID баджа
   */
  id: number;
  /**
   * Текст баджа
   */
  text: string;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface CartFragment_sku_discountTimer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface CartFragment_sku_discountTimer {
  __typename: "SkuDiscountTimer";
  /**
   * Дата окончания скидки
   */
  endDate: any;
  /**
   * Иконка
   */
  image: CartFragment_sku_discountTimer_image;
  /**
   * Текст для отображения таймера
   */
  text: string | null;
  /**
   * hex цвет текста
   */
  textColor: string;
}

export interface CartFragment_sku_photo_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface CartFragment_sku_photo_original {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface CartFragment_sku_photo {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: CartFragment_sku_photo_link;
  /**
   * Ссылка на оригинал фотографии
   */
  original: CartFragment_sku_photo_original;
}

export interface CartFragment_sku_photo360 {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface CartFragment_sku_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
}

export interface CartFragment_sku_product_badges {
  __typename: "BottomIconTextBadge" | "BottomTextBadge" | "TopTextBadge";
  /**
   * Цвет фона бейджа
   */
  backgroundColor: string;
  /**
   * ID бейджа
   */
  id: number;
  /**
   * Текст на бейдже
   */
  text: string;
  /**
   * Цвет текста на бейдже
   */
  textColor: string;
}

export interface CartFragment_sku_product_category_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface CartFragment_sku_product_category_parentList {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface CartFragment_sku_product_category_children {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
}

export interface CartFragment_sku_product_category_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface CartFragment_sku_product_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
  /**
   * Category parent.
   */
  parent: CartFragment_sku_product_category_parent | null;
  /**
   * List of parent categories. Starts from the root.
   */
  parentList: CartFragment_sku_product_category_parentList[];
  /**
   * List of category children.
   */
  children: CartFragment_sku_product_category_children[];
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category SEO fields.
   */
  seo: CartFragment_sku_product_category_seo;
}

export interface CartFragment_sku_product_characteristics {
  __typename: "ProductCharacteristic";
  /**
   * ID характеристики
   */
  id: number;
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * Тип отображения значения характеристики
   */
  type: CharacteristicType;
}

export interface CartFragment_sku_product_comments {
  __typename: "ProductComment";
  type: string;
  value: string;
}

export interface CartFragment_sku_product_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface CartFragment_sku_product_shop_avatar {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface CartFragment_sku_product_shop_seller_legalRecords {
  __typename: "LegalRecord";
  /**
   * Заголовок: ИНН, ОГРН и т.д., может быть пустым
   */
  name: string | null;
  /**
   * Значение
   */
  value: string;
}

export interface CartFragment_sku_product_shop_seller {
  __typename: "SellerInfo";
  /**
   * ID аккаунта продавца
   */
  accountId: number;
  /**
   * Список юр. данных для отображения
   */
  legalRecords: CartFragment_sku_product_shop_seller_legalRecords[];
}

export interface CartFragment_sku_product_shop {
  __typename: "Shop";
  /**
   * Аватарка магазина
   */
  avatar: CartFragment_sku_product_shop_avatar | null;
  /**
   * Количество отзывов магазина
   */
  feedbackQuantity: number;
  /**
   * ID магазина
   */
  id: number;
  /**
   * Является ли магазин официальным
   */
  official: boolean;
  /**
   * Количество заказов магазина
   */
  ordersQuantity: number;
  /**
   * Рейтинг магазина
   */
  rating: number;
  /**
   * Информация о продавце
   */
  seller: CartFragment_sku_product_shop_seller | null;
  /**
   * Короткое название магазина
   */
  shortTitle: string | null;
  /**
   * Название магазина
   */
  title: string;
  /**
   * Ссылка на магазин
   */
  url: string;
}

export interface CartFragment_sku_product_skuList {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface CartFragment_sku_product {
  __typename: "Product";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Свойства товара
   */
  attributes: string[];
  /**
   * Массив бейджей товара
   */
  badges: CartFragment_sku_product_badges[];
  /**
   * Информация о категории продукта
   */
  category: CartFragment_sku_product_category | null;
  /**
   * Массив характеристик продукта
   */
  characteristics: CartFragment_sku_product_characteristics[];
  /**
   * Массив содержащий размерную сетку, инструкцию, состав, сертификацию
   */
  comments: CartFragment_sku_product_comments[];
  /**
   * Развернутое описание продукта
   */
  description: string;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Флаг на наличие вертикальной фотографии
   */
  hasVerticalPhoto: boolean;
  /**
   * ID продукта
   */
  id: number;
  /**
   * Зачеркнутая цена для продукта
   */
  minFullPrice: number;
  /**
   * Минимальная цена для продукта
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: CartFragment_sku_product_offer | null;
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Информация о магазине, который продает этот товар
   */
  shop: CartFragment_sku_product_shop | null;
  /**
   * Краткое описание продукта
   */
  shortDescription: string | null;
  /**
   * Массив SKU
   */
  skuList: CartFragment_sku_product_skuList[];
  /**
   * Название продукта
   */
  title: string;
}

export interface CartFragment_sku_properties_filter {
  __typename: "Filter";
  description: string | null;
  /**
   * Product filter identifier.
   */
  id: number;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  title: string;
  type: FilterType;
}

export interface CartFragment_sku_properties {
  __typename: "FilterValue";
  description: string | null;
  filter: CartFragment_sku_properties_filter;
  /**
   * Product filter value identifier.
   */
  id: number;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface CartFragment_sku_vat {
  __typename: "SkuVat";
  /**
   * Цена без НДС
   */
  price: number;
  /**
   * Тип НДС
   */
  type: ProductVat;
  /**
   * Сумма НДС
   */
  vatAmount: number;
  /**
   * Коэфициент НДС
   */
  vatRate: number;
}

export interface CartFragment_sku_video {
  __typename: "Video";
  /**
   * Ключ видео
   */
  key: string;
  /**
   * Ссылка на видео
   */
  url: string;
}

export interface CartFragment_sku {
  __typename: "Sku";
  /**
   * Доступное количество по SKU
   */
  availableAmount: number;
  /**
   * Штрихкод СКУ
   */
  barcode: string;
  /**
   * Значения характеристик SKU
   */
  characteristicValues: CartFragment_sku_characteristicValues[];
  /**
   * Размеры SKU
   */
  dimensions: CartFragment_sku_dimensions;
  /**
   * Цветные баджи рядом с ценой
   */
  discountBadge: CartFragment_sku_discountBadge | null;
  /**
   * Плашки с таймером для конкретного СКУ
   */
  discountTimer: CartFragment_sku_discountTimer | null;
  /**
   * Стоимость SKU без скидки (зачеркнутая цена)
   */
  fullPrice: number;
  /**
   * ID SKU
   */
  id: number;
  /**
   * Основная фотография для СКУ
   */
  photo: CartFragment_sku_photo;
  /**
   * Фотографии 360
   */
  photo360: CartFragment_sku_photo360[] | null;
  /**
   * Массив фотографий для СКУ
   */
  photos: CartFragment_sku_photos[];
  /**
   * Продукт, к которому относится SKU
   */
  product: CartFragment_sku_product;
  /**
   * Свойства СКУ, в дизайне называются характеристиками
   */
  properties: CartFragment_sku_properties[] | null;
  /**
   * Цена продажи СКУ
   */
  sellPrice: number;
  /**
   * SKU title, не используется на клиентах
   */
  skuTitle: string;
  /**
   * НДС SKU
   */
  vat: CartFragment_sku_vat | null;
  /**
   * Видео по SKU
   */
  video: CartFragment_sku_video | null;
  /**
   * Вес SKU
   */
  weight: number | null;
}

export interface CartFragment {
  __typename: "CartItem";
  amount: number;
  sku: CartFragment_sku;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CatalogCardFragment
// ====================================================

export interface CatalogCardFragment_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface CatalogCardFragment_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface CatalogCardFragment_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type CatalogCardFragment_badges = CatalogCardFragment_badges_BottomIconTextBadge | CatalogCardFragment_badges_BottomTextBadge;

export interface CatalogCardFragment_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface CatalogCardFragment_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: CatalogCardFragment_photos_link;
}

export interface CatalogCardFragment {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: CatalogCardFragment_offer | null;
  /**
   * Массив бейджей
   */
  badges: CatalogCardFragment_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: CatalogCardFragment_photos[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DefaultCardFragment
// ====================================================

export interface DefaultCardFragment_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface DefaultCardFragment_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface DefaultCardFragment_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type DefaultCardFragment_badges = DefaultCardFragment_badges_BottomIconTextBadge | DefaultCardFragment_badges_BottomTextBadge;

export interface DefaultCardFragment {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: DefaultCardFragment_offer | null;
  /**
   * Массив бейджей
   */
  badges: DefaultCardFragment_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SkuGroupCardFragment
// ====================================================

export interface SkuGroupCardFragment_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface SkuGroupCardFragment_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface SkuGroupCardFragment_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type SkuGroupCardFragment_badges = SkuGroupCardFragment_badges_BottomIconTextBadge | SkuGroupCardFragment_badges_BottomTextBadge;

export interface SkuGroupCardFragment_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SkuGroupCardFragment_photos_previewLink {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface SkuGroupCardFragment_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: SkuGroupCardFragment_photos_link;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  previewLink: SkuGroupCardFragment_photos_previewLink;
}

export interface SkuGroupCardFragment_characteristicValues_characteristic_values {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
}

export interface SkuGroupCardFragment_characteristicValues_characteristic {
  __typename: "ProductCharacteristic";
  /**
   * Массив значений по характеристике
   */
  values: SkuGroupCardFragment_characteristicValues_characteristic_values[];
  /**
   * Заголовок характеристики
   */
  title: string;
  /**
   * ID характеристики
   */
  id: number;
}

export interface SkuGroupCardFragment_characteristicValues {
  __typename: "CharacteristicValue";
  /**
   * ID значения
   */
  id: number;
  /**
   * Для хар-ки цвет - RGB значение
   */
  value: string;
  /**
   * Заголовок значения характеристики
   */
  title: string;
  /**
   * Характеристика
   */
  characteristic: SkuGroupCardFragment_characteristicValues_characteristic;
}

export interface SkuGroupCardFragment {
  __typename: "SkuGroupCard";
  /**
   * Является ли товаром 18+
   */
  adult: boolean;
  /**
   * Добавлен ли товар в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов для СКУ группы
   */
  feedbackQuantity: number;
  /**
   * ID СКУ группы (не продукта)
   */
  id: number;
  /**
   * Цена для отображения в каталоге до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в каталоге с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Плашка со скидкой с таймером
   */
  offer: SkuGroupCardFragment_offer | null;
  /**
   * Массив бейджей товара
   */
  badges: SkuGroupCardFragment_badges[];
  /**
   * Количество заказов для СКУ группы
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг товара
   */
  rating: number;
  /**
   * Название товара
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Фотографии СКУ группы (приходит только главная пока)
   */
  photos: SkuGroupCardFragment_photos[];
  /**
   * Значения характеристик для конкретной СКУ группы
   */
  characteristicValues: SkuGroupCardFragment_characteristicValues[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CategoryFragment
// ====================================================

export interface CategoryFragment_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
}

export interface CategoryFragment_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface CategoryFragment {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Link to the category icon image.
   */
  icon: string | null;
  /**
   * Category parent.
   */
  parent: CategoryFragment_parent | null;
  /**
   * Category SEO fields.
   */
  seo: CategoryFragment_seo;
  /**
   * Category title.
   */
  title: string;
  /**
   * Reports if category contains adult content.
   */
  adult: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CategoryShortFragment
// ====================================================

export interface CategoryShortFragment_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface CategoryShortFragment {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category parent.
   */
  parent: CategoryShortFragment_parent | null;
  /**
   * Category title.
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FastCategoryFragment
// ====================================================

export interface FastCategoryFragment_parent {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface FastCategoryFragment_seo {
  __typename: "SeoCategoryFields";
  /**
   * SEO header.
   */
  header: string | null;
  /**
   * SEO meta tag.
   */
  metaTag: string | null;
}

export interface FastCategoryFragment {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category parent.
   */
  parent: FastCategoryFragment_parent | null;
  /**
   * Category title.
   */
  title: string;
  /**
   * Category SEO fields.
   */
  seo: FastCategoryFragment_seo;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FacetFragment
// ====================================================

export interface FacetFragment_filter {
  __typename: "Filter";
  /**
   * Product filter identifier.
   */
  id: number;
  title: string;
  type: FilterType;
  /**
   * Non-null for RANGED_VALUE
   */
  measurementUnit: string | null;
  description: string | null;
}

export interface FacetFragment_buckets_filterValue {
  __typename: "FilterValue";
  /**
   * Product filter value identifier.
   */
  id: number;
  description: string | null;
  /**
   * Link to an image
   */
  image: string | null;
  name: string;
}

export interface FacetFragment_buckets {
  __typename: "FacetBucket";
  /**
   * Filter value.
   */
  filterValue: FacetFragment_buckets_filterValue;
  /**
   * Total number of items with the bucket's filter value.
   */
  total: number;
}

export interface FacetFragment_range {
  __typename: "FacetRange";
  /**
   * Minimal value.
   */
  min: number;
  /**
   * Maximum value.
   */
  max: number;
}

export interface FacetFragment {
  __typename: "Facet";
  /**
   * Product filter.
   */
  filter: FacetFragment_filter;
  /**
   * Facet buckets.
   */
  buckets: FacetFragment_buckets[] | null;
  /**
   * Facet range.
   */
  range: FacetFragment_range | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InlineBannerFragment
// ====================================================

export interface InlineBannerFragment_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface InlineBannerFragment {
  __typename: "InlineBanner";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * Ссылка на большую фотографию баннера
   */
  image: InlineBannerFragment_image;
  /**
   * Ссылка, которая открывается при нажатии на баннер
   */
  link: string | null;
  /**
   * ID блока баннера
   */
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ExtendableOfferFragment
// ====================================================

export interface ExtendableOfferFragment_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface ExtendableOfferFragment_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface ExtendableOfferFragment_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type ExtendableOfferFragment_products_badges = ExtendableOfferFragment_products_badges_BottomIconTextBadge | ExtendableOfferFragment_products_badges_BottomTextBadge;

export interface ExtendableOfferFragment_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface ExtendableOfferFragment_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: ExtendableOfferFragment_products_photos_link;
}

export interface ExtendableOfferFragment_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface ExtendableOfferFragment_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: ExtendableOfferFragment_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: ExtendableOfferFragment_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: ExtendableOfferFragment_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: ExtendableOfferFragment_products_cardNearestDeliveryInfo | null;
}

export interface ExtendableOfferFragment_category {
  __typename: "Category";
  /**
   * Category title.
   */
  title: string;
  /**
   * Category identifier.
   */
  id: number;
}

export interface ExtendableOfferFragment_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface ExtendableOfferFragment {
  __typename: "ExtendableOffer";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * ID подборки
   */
  id: number;
  /**
   * Массив карточек товара
   */
  products: ExtendableOfferFragment_products[];
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: ExtendableOfferFragment_category;
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: ExtendableOfferFragment_adMarker | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VerticalOfferFragment
// ====================================================

export interface VerticalOfferFragment_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
}

export interface VerticalOfferFragment_content_CollectionBlock {
  __typename: "CollectionBlock" | "PromoImageBlock";
}

export interface VerticalOfferFragment_content_CardBlock_content_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface VerticalOfferFragment_content_CardBlock_content_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface VerticalOfferFragment_content_CardBlock_content_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type VerticalOfferFragment_content_CardBlock_content_badges = VerticalOfferFragment_content_CardBlock_content_badges_BottomIconTextBadge | VerticalOfferFragment_content_CardBlock_content_badges_BottomTextBadge;

export interface VerticalOfferFragment_content_CardBlock_content_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface VerticalOfferFragment_content_CardBlock_content_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: VerticalOfferFragment_content_CardBlock_content_photos_link;
}

export interface VerticalOfferFragment_content_CardBlock_content_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface VerticalOfferFragment_content_CardBlock_content {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: VerticalOfferFragment_content_CardBlock_content_offer | null;
  /**
   * Массив бейджей
   */
  badges: VerticalOfferFragment_content_CardBlock_content_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: VerticalOfferFragment_content_CardBlock_content_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: VerticalOfferFragment_content_CardBlock_content_cardNearestDeliveryInfo | null;
}

export interface VerticalOfferFragment_content_CardBlock {
  __typename: "CardBlock";
  /**
   * Массив карточек товара
   */
  content: VerticalOfferFragment_content_CardBlock_content[];
}

export interface VerticalOfferFragment_content_CarouselOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface VerticalOfferFragment_content_CarouselOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface VerticalOfferFragment_content_CarouselOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface VerticalOfferFragment_content_CarouselOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type VerticalOfferFragment_content_CarouselOffer_products_badges = VerticalOfferFragment_content_CarouselOffer_products_badges_BottomIconTextBadge | VerticalOfferFragment_content_CarouselOffer_products_badges_BottomTextBadge;

export interface VerticalOfferFragment_content_CarouselOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface VerticalOfferFragment_content_CarouselOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: VerticalOfferFragment_content_CarouselOffer_products_photos_link;
}

export interface VerticalOfferFragment_content_CarouselOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface VerticalOfferFragment_content_CarouselOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: VerticalOfferFragment_content_CarouselOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: VerticalOfferFragment_content_CarouselOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: VerticalOfferFragment_content_CarouselOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: VerticalOfferFragment_content_CarouselOffer_products_cardNearestDeliveryInfo | null;
}

export interface VerticalOfferFragment_content_CarouselOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface VerticalOfferFragment_content_CarouselOffer {
  __typename: "CarouselOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: VerticalOfferFragment_content_CarouselOffer_category;
  /**
   * Массив карточек товара
   */
  products: VerticalOfferFragment_content_CarouselOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: VerticalOfferFragment_content_CarouselOffer_adMarker | null;
}

export interface VerticalOfferFragment_content_ImageOffer_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface VerticalOfferFragment_content_ImageOffer_category {
  __typename: "Category";
  /**
   * Category identifier.
   */
  id: number;
  /**
   * Category title.
   */
  title: string;
}

export interface VerticalOfferFragment_content_ImageOffer_products_offer {
  __typename: "ProductOffer";
  /**
   * Дата окончания временной скидки
   */
  due: any | null;
  /**
   * Иконка временной скидки
   */
  icon: string | null;
  /**
   * Текст таймера
   */
  text: string | null;
  /**
   * Цвет текста
   */
  textColor: string | null;
}

export interface VerticalOfferFragment_content_ImageOffer_products_badges_BottomIconTextBadge {
  __typename: "BottomIconTextBadge" | "TopTextBadge";
}

export interface VerticalOfferFragment_content_ImageOffer_products_badges_BottomTextBadge {
  __typename: "BottomTextBadge";
  backgroundColor: string;
  description: string | null;
  id: number;
  link: string | null;
  text: string;
  textColor: string;
}

export type VerticalOfferFragment_content_ImageOffer_products_badges = VerticalOfferFragment_content_ImageOffer_products_badges_BottomIconTextBadge | VerticalOfferFragment_content_ImageOffer_products_badges_BottomTextBadge;

export interface VerticalOfferFragment_content_ImageOffer_products_photos_link {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
  /**
   * В низком качестве
   */
  low: string;
}

export interface VerticalOfferFragment_content_ImageOffer_products_photos {
  __typename: "Photo";
  /**
   * Ключ фотографии
   */
  key: string;
  /**
   * Объект ссылок (HQ + LQ) на вариацию фото по переданному параметру размера
   */
  link: VerticalOfferFragment_content_ImageOffer_products_photos_link;
}

export interface VerticalOfferFragment_content_ImageOffer_products_cardNearestDeliveryInfo {
  __typename: "CardNearestDeliveryInfo";
  nearestDelivery: any | null;
}

export interface VerticalOfferFragment_content_ImageOffer_products {
  __typename: "SkuGroupCard" | "ProductCard";
  /**
   * Является ли 18+
   */
  adult: boolean;
  /**
   * Добавлено ли в избранное
   */
  favorite: boolean;
  /**
   * Количество отзывов
   */
  feedbackQuantity: number;
  /**
   * Catalog card entity identifier.
   */
  id: number;
  /**
   * Цена для отображения в карточке товара до скидки (минимальная цена до скидки из всех SKU)
   */
  minFullPrice: number;
  /**
   * Цена для отображения в карточке товара с учетом скидки (минимальная актуальная цена из всех SKU)
   */
  minSellPrice: number;
  /**
   * Информация о временной скидке
   */
  offer: VerticalOfferFragment_content_ImageOffer_products_offer | null;
  /**
   * Массив бейджей
   */
  badges: VerticalOfferFragment_content_ImageOffer_products_badges[];
  /**
   * Количество заказов
   */
  ordersQuantity: number;
  /**
   * ID продукта
   */
  productId: number;
  /**
   * Рейтинг
   */
  rating: number;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о наличии
   */
  inStock: boolean;
  /**
   * Массив фотографий
   */
  photos: VerticalOfferFragment_content_ImageOffer_products_photos[];
  /**
   * Информация о доставке
   */
  cardNearestDeliveryInfo: VerticalOfferFragment_content_ImageOffer_products_cardNearestDeliveryInfo | null;
}

export interface VerticalOfferFragment_content_ImageOffer_adMarker {
  __typename: "AdMarker";
  /**
   * Ad marker identifier.
   */
  marker: string;
  orgInn: string | null;
  orgName: string;
}

export interface VerticalOfferFragment_content_ImageOffer {
  __typename: "ImageOffer";
  /**
   * ID подборки
   */
  id: number;
  /**
   * Ссылка на большую фотографию подборки
   */
  image: VerticalOfferFragment_content_ImageOffer_image;
  /**
   * Заголовок
   */
  title: string;
  /**
   * Информация о категории подборки
   */
  category: VerticalOfferFragment_content_ImageOffer_category;
  /**
   * Массив карточек товара
   */
  products: VerticalOfferFragment_content_ImageOffer_products[];
  /**
   * Маркировка рекламы для подборки
   */
  adMarker: VerticalOfferFragment_content_ImageOffer_adMarker | null;
}

export interface VerticalOfferFragment_content_InlineBanner_image {
  __typename: "PhotoLink";
  /**
   * В высоком качестве
   */
  high: string;
}

export interface VerticalOfferFragment_content_InlineBanner {
  __typename: "InlineBanner";
  /**
   * Подзаголовок или описание
   */
  description: string | null;
  /**
   * Ссылка на большую фотографию баннера
   */
  image: VerticalOfferFragment_content_InlineBanner_image;
  /**
   * Ссылка, которая открывается при нажатии на баннер
   */
  link: string | null;
  /**
   * ID блока баннера
   */
  id: number;
}

export type VerticalOfferFragment_content = VerticalOfferFragment_content_CollectionBlock | VerticalOfferFragment_content_CardBlock | VerticalOfferFragment_content_CarouselOffer | VerticalOfferFragment_content_ImageOffer | VerticalOfferFragment_content_InlineBanner;

export interface VerticalOfferFragment {
  __typename: "VerticalOffer";
  /**
   * ID таба
   */
  id: number;
  /**
   * Заголовок таба
   */
  title: string;
  /**
   * Категория для оффера
   */
  category: VerticalOfferFragment_category | null;
  /**
   * Массив элементов таба главной страницы
   */
  content: VerticalOfferFragment_content[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Тип характеристики
 */
export enum CharacteristicType {
  COLOR = "COLOR",
  IMAGE = "IMAGE",
  TEXT = "TEXT",
}

/**
 * День недели
 */
export enum DayOfWeek {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum DeliveryPointType {
  DELIVERY_POINT = "DELIVERY_POINT",
  MAGNIT_OFFICE = "MAGNIT_OFFICE",
  MAGNIT_SHOP = "MAGNIT_SHOP",
  RUSSIAN_POST = "RUSSIAN_POST",
}

export enum DeliveryType {
  COURIER = "COURIER",
  DELIVERY_POINT = "DELIVERY_POINT",
  METASHIP = "METASHIP",
  POSTAMAT = "POSTAMAT",
  RUSSIAN_POST = "RUSSIAN_POST",
}

/**
 * Тип запрашиваемой главной страницы
 */
export enum DisplayType {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  OMNI_MOBILE = "OMNI_MOBILE",
}

export enum FeedbackFilterType {
  PHOTOS = "PHOTOS",
}

export enum FeedbackSortType {
  DATE_DESC = "DATE_DESC",
  RATING_ASC = "RATING_ASC",
  RATING_DESC = "RATING_DESC",
  RELEVANCE = "RELEVANCE",
}

/**
 * Product filter type.
 */
export enum FilterInputType {
  LIST = "LIST",
  RANGE = "RANGE",
}

export enum FilterType {
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  MULTIPLE_CHOICE_TAG = "MULTIPLE_CHOICE_TAG",
  RANGED_ENUM = "RANGED_ENUM",
  RANGED_VALUE = "RANGED_VALUE",
  SINGLE_CHOICE = "SINGLE_CHOICE",
  SINGLE_CHOICE_TAG = "SINGLE_CHOICE_TAG",
}

export enum PostamatType {
  HALVA = "HALVA",
  POSTAMAT = "POSTAMAT",
  RUSSIAN_POST = "RUSSIAN_POST",
}

export enum ProductActionLocation {
  PRODUCT_BOTTOM_BAR = "PRODUCT_BOTTOM_BAR",
}

export enum ProductActionType {
  BANNER_ACTION = "BANNER_ACTION",
  MOTIVATION = "MOTIVATION",
  WISH_SALE = "WISH_SALE",
}

/**
 * Исключили 'Лучшая цена', будет отдельная плашка под это
 */
export enum ProductPaymentOptionType {
  DOLYAME = "DOLYAME",
  INSTALLMENT = "INSTALLMENT",
  PODELI = "PODELI",
}

export enum ProductVat {
  NONE = "NONE",
  VAT0 = "VAT0",
  VAT10 = "VAT10",
  VAT110 = "VAT110",
  VAT120 = "VAT120",
  VAT20 = "VAT20",
  VAT5 = "VAT5",
  VAT7 = "VAT7",
}

/**
 * Adult content showing flag.
 */
export enum ShowAdultContent {
  FALSE = "FALSE",
  NONE = "NONE",
  TRUE = "TRUE",
}

/**
 * Search query result sorting.
 */
export enum Sort {
  BY_DATE_ADDED_ASC = "BY_DATE_ADDED_ASC",
  BY_DATE_ADDED_DESC = "BY_DATE_ADDED_DESC",
  BY_ORDERS_NUMBER_ASC = "BY_ORDERS_NUMBER_ASC",
  BY_ORDERS_NUMBER_DESC = "BY_ORDERS_NUMBER_DESC",
  BY_PRICE_ASC = "BY_PRICE_ASC",
  BY_PRICE_DESC = "BY_PRICE_DESC",
  BY_RATING_ASC = "BY_RATING_ASC",
  BY_RATING_DESC = "BY_RATING_DESC",
  BY_RELEVANCE_DESC = "BY_RELEVANCE_DESC",
}

export enum SortBy {
  date = "date",
  default = "default",
  orders = "orders",
  price = "price",
  rating = "rating",
}

export enum SortOrder {
  ascending = "ascending",
  descending = "descending",
}

/**
 * Параметр размера фотографии
 */
export enum Transformation {
  ORIGINAL = "ORIGINAL",
  PRODUCT_120 = "PRODUCT_120",
  PRODUCT_240 = "PRODUCT_240",
  PRODUCT_24034 = "PRODUCT_24034",
  PRODUCT_480 = "PRODUCT_480",
  PRODUCT_540 = "PRODUCT_540",
  PRODUCT_60 = "PRODUCT_60",
  PRODUCT_720 = "PRODUCT_720",
  PRODUCT_80 = "PRODUCT_80",
  PRODUCT_800 = "PRODUCT_800",
}

export interface CartCheckoutInformationInput {
  address?: string | null;
  cityId?: number | null;
  deliveryPolygon?: DeliveryPolygonInput | null;
  deselectedCartItems: (CartCheckoutItem | null)[];
  isWriteOffPoints?: boolean | null;
  promoCode?: string | null;
  selectedCartItems: (CartCheckoutItem | null)[];
  selectedDelivery?: SelectedDelivery | null;
}

export interface CartCheckoutItem {
  amount: number;
  skuId: number;
}

export interface CartItemInput {
  skuId: number;
  amount: number;
  selected?: boolean | null;
}

export interface DeliveryPolygonInput {
  bottomRight: GeoPointInput;
  topLeft: GeoPointInput;
}

/**
 * Product filter input.
 */
export interface FilterInput {
  filterType: FilterInputType;
  id: string;
  range?: FilterRangeInput | null;
  list?: FilterListInput | null;
}

/**
 * List filter input values.
 */
export interface FilterListInput {
  values: string[];
}

/**
 * Range filter input values. At least one of the boundaries must be not null.
 */
export interface FilterRangeInput {
  min?: number | null;
  max?: number | null;
}

export interface GeoPointInput {
  latitude: number;
  longitude: number;
}

/**
 * Get promotion shelf input.
 */
export interface GetPromotionShelfInput {
  text?: string | null;
  categoryId?: string | null;
  correctQuery?: boolean | null;
}

/**
 * Search suggestions query input.
 */
export interface GetSuggestionsInput {
  text: string;
  popularSuggestionsLimit?: number | null;
  textSuggestionsLimit?: number | null;
  catalogCardSuggestionsLimit?: number | null;
  categorySuggestionsLimit?: number | null;
  shopSuggestionsLimit?: number | null;
}

/**
 * Search query input.
 */
export interface MakeSearchQueryInput {
  text?: string | null;
  categoryId?: string | null;
  offerCategoryId?: string | null;
  shopId?: string | null;
  showAdultContent: ShowAdultContent;
  filters: FilterInput[];
  sort: Sort;
  pagination: PaginationInput;
  fastCategoriesLevelOffset?: number | null;
  fastCategoriesLimit?: number | null;
  getFastCategories?: boolean | null;
  correctQuery?: boolean | null;
  token?: string | null;
  getPromotionItems?: boolean | null;
  link?: string | null;
}

/**
 * Pagination input parameters.
 */
export interface PaginationInput {
  offset: number;
  limit: number;
}

export interface PagingOptions {
  size: number;
  page: number;
}

export interface PricingOptions {
  min?: number | null;
  max?: number | null;
}

export interface SearchArgs {
  query: string;
  categoryId?: number | null;
  dshopCategoryId?: number | null;
  sort?: SortOptions | null;
  paging: PagingOptions;
  dedicatedShopId?: number | null;
  debug?: boolean | null;
  price?: PricingOptions | null;
  dshopFilterCategories?: number[] | null;
  offerID?: number | null;
}

export interface SelectedDelivery {
  city?: string | null;
  deliveryPointKey?: string | null;
  deliveryServiceCode?: string | null;
  id?: number | null;
  type: DeliveryType;
}

export interface SortOptions {
  by?: SortBy | null;
  order?: SortOrder | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
